var _g, _polygon, _path, _path2, _path3, _path4, _path5, _path6, _polygon2, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPagenotfound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-179"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.52,96.89a2.67,2.67,0,0,1,2.79,0c.23.14.47.27.71.4l.74.38a2.63,2.63,0,0,1,1.55,2.3l.11,3.43,11.16-.35-.1-3.43a2.68,2.68,0,0,1,1.4-2.41,13.84,13.84,0,0,0,1.42-.87,2.66,2.66,0,0,1,2.77-.18l3,1.62L91.36,88l-3-1.61A2.66,2.66,0,0,1,87,83.93c0-.56,0-1.11,0-1.66a2.64,2.64,0,0,1,1.23-2.5L91.05,78l-5.89-9.49-2.93,1.81a2.63,2.63,0,0,1-2.77,0c-.23-.14-.47-.27-.71-.4s-.49-.26-.74-.37a2.66,2.66,0,0,1-1.55-2.31l-.11-3.43-11.16.34.11,3.42a2.67,2.67,0,0,1-1.4,2.41,16,16,0,0,0-1.42.88A2.68,2.68,0,0,1,59.7,71l-3-1.62-5.28,9.85,3,1.61a2.66,2.66,0,0,1,1.39,2.41c0,.56,0,1.12,0,1.67a2.64,2.64,0,0,1-1.23,2.5l-2.91,1.8,5.89,9.49Zm2.8-17.63a9.15,9.15,0,1,1,3.74,12.38A9.16,9.16,0,0,1,63.32,79.26Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.83,162.45l-.12-3.93a2.15,2.15,0,0,0-1.26-1.86c-.26-.12-.51-.25-.77-.39s-.49-.27-.73-.42a2.18,2.18,0,0,0-2.27,0l-.26-.42.26.42-3.33,2.07-6.42-10.34,3.34-2.06a2.17,2.17,0,0,0,1-2,16.58,16.58,0,0,1-.05-1.73,2.16,2.16,0,0,0-1.12-2l-3.46-1.85,5.76-10.72,3.45,1.85a2.15,2.15,0,0,0,2.25-.15,15.69,15.69,0,0,1,1.47-.91,2.16,2.16,0,0,0,1.14-2l-.13-3.92,12.17-.38.11,3.93a2.19,2.19,0,0,0,1.27,1.88,7.69,7.69,0,0,1,.76.38c.25.13.5.27.74.42a2.15,2.15,0,0,0,2.25,0l3.35-2.08,6.42,10.34-3.34,2.07a2.17,2.17,0,0,0-1,2,16.29,16.29,0,0,1,.06,1.71,2.14,2.14,0,0,0,1.12,2l3.46,1.85L396.18,157l-3.45-1.85a2.13,2.13,0,0,0-2.25.14c-.47.33-1,.63-1.46.91a2.12,2.12,0,0,0-1.14,2l.12,3.92Zm-4.05-7.93a3.23,3.23,0,0,1,1.68.48c.23.14.46.27.7.39s.47.25.71.36a3.14,3.14,0,0,1,1.84,2.74l.09,2.93,10.17-.31-.09-2.93a3.13,3.13,0,0,1,1.66-2.86c.46-.26.92-.54,1.37-.85a3.15,3.15,0,0,1,3.29-.21l2.58,1.38,4.8-9L398,145.3a3.14,3.14,0,0,1-1.65-2.86c0-.53,0-1.07-.05-1.61a3.14,3.14,0,0,1,1.46-3l2.49-1.54-5.36-8.64-2.5,1.55a3.14,3.14,0,0,1-3.3,0l-.69-.39c-.24-.13-.47-.25-.71-.36a3.17,3.17,0,0,1-1.85-2.75l-.08-2.93-10.17.32.1,2.92a3.16,3.16,0,0,1-1.66,2.86,15,15,0,0,0-1.38.85,3.13,3.13,0,0,1-3.29.21l-2.58-1.38-4.8,9,2.57,1.38a3.17,3.17,0,0,1,1.65,2.86,14.54,14.54,0,0,0,.05,1.62,3.16,3.16,0,0,1-1.47,3l-2.48,1.53,5.36,8.64,2.48-1.54A3.16,3.16,0,0,1,371.78,154.52Zm9.49-2.77a9.66,9.66,0,1,1,8.51-5.09A9.58,9.58,0,0,1,381.27,151.75Zm0-18.3a8.74,8.74,0,0,0-2.52.37,8.63,8.63,0,1,0,2.52-.37Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.53,260.05a1.87,1.87,0,0,1,.91,1.73c0,.19,0,.38,0,.58s0,.39,0,.58a1.85,1.85,0,0,1-.91,1.72l-2.08,1.2,3.91,6.78,2.08-1.2a1.85,1.85,0,0,1,1.95.06,11.53,11.53,0,0,0,1,.59,1.85,1.85,0,0,1,1,1.65v2.4h7.83v-2.4a1.86,1.86,0,0,1,1-1.65,9.19,9.19,0,0,0,1-.59,1.85,1.85,0,0,1,2-.06l2.08,1.2,3.91-6.78-2.09-1.21a1.86,1.86,0,0,1-.9-1.72c0-.19,0-.38,0-.57s0-.39,0-.58a1.85,1.85,0,0,1,.91-1.72l2.08-1.2-3.91-6.78-2.07,1.2a1.85,1.85,0,0,1-2-.07,11.41,11.41,0,0,0-1-.58,1.87,1.87,0,0,1-1-1.66v-2.39h-7.83V251a1.87,1.87,0,0,1-1,1.66,9.12,9.12,0,0,0-1,.58,1.85,1.85,0,0,1-1.95.07l-2.08-1.2-3.91,6.78Zm11.81-4.11a6.41,6.41,0,1,1-6.41,6.42A6.42,6.42,0,0,1,540.34,255.94Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.06,121.27A30.47,30.47,0,1,0,677.53,90.8,30.47,30.47,0,0,0,647.06,121.27Zm16.24,0a14.24,14.24,0,1,1,14.23,14.23A14.23,14.23,0,0,1,663.3,121.27Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "671.67 92.06 683.39 92.06 682.74 83.77 672.32 83.77 671.67 92.06",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "693.98 96.01 702.26 104.3 707.67 97.97 700.3 90.6 693.98 96.01",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "706.96 114.57 706.96 126.29 715.25 125.64 715.25 115.22 706.96 114.57",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "703.01 136.88 694.72 145.16 701.04 150.57 708.41 143.2 703.01 136.88",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "684.45 149.86 672.73 149.86 673.38 158.15 683.8 158.15 684.45 149.86",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "662.14 145.91 653.86 137.62 648.45 143.95 655.82 151.32 662.14 145.91",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "649.16 127.35 649.16 115.63 640.87 116.28 640.87 126.7 649.16 127.35",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "653.11 105.04 661.4 96.76 655.07 91.35 647.7 98.72 653.11 105.04",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.43,339.81H192.08l-.53-6.84a30.28,30.28,0,0,1-11.32-4.32L175,333.16l-8-8,4.32-5.06a30.31,30.31,0,0,1-4.86-11.22l-6.86-.53V297l6.78-.54a30.29,30.29,0,0,1,4.56-11.1l-4.69-5.48,8-8,5.5,4.71a30.55,30.55,0,0,1,10.72-4.43l.59-7.68h11.35l.6,7.68a30.18,30.18,0,0,1,10.4,4.22l6.12-5.24,8,8-5.14,6a30.28,30.28,0,0,1,4.45,10.17l8.09.63v11.36l-7.73.59a30.33,30.33,0,0,1-4,10.6l5.08,5.92-8,8-5.57-4.75A30.43,30.43,0,0,1,204,332.53Zm-10.42-1h9.49l.56-7.09.36-.08a29.58,29.58,0,0,0,11-5l.32-.23,5.47,4.66,6.72-6.71L222,318.56l.19-.31a29.38,29.38,0,0,0,4.11-10.93l.07-.39,7.59-.58v-9.5l-7.9-.62-.08-.36a29.52,29.52,0,0,0-4.6-10.5l-.22-.32,5-5.88-6.72-6.72-6,5.13-.32-.21A29.37,29.37,0,0,0,202.4,273l-.37-.07-.59-7.51H192l-.58,7.51L191,273a29.39,29.39,0,0,0-11,4.57l-.13.08h-.34l-.15-.12-5.08-4.35-6.71,6.72,4.59,5.36-.22.32A29.35,29.35,0,0,0,167.23,297l-.07.38-6.62.53v9.49l6.69.52.08.38a29.23,29.23,0,0,0,5,11.52l.23.32-4.23,4.95L175,331.8l5.14-4.39.31.2a29.33,29.33,0,0,0,11.63,4.44l.39.06Zm3.69-21.65a14.73,14.73,0,1,1,14.74-14.73A14.74,14.74,0,0,1,196.7,317.16Zm0-28.46a13.73,13.73,0,1,0,13.74,13.73A13.75,13.75,0,0,0,196.7,288.7Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.27,357.79c-5.74.1-20.22.35-25.77.41l-8.69.05h-.45v-.46l0-11.19v-.5h.5l17.23.07c4.29,0,12.94.13,17.23.19h.25v.24l-.24,11.19Zm0,0L113,346.6l.24.24c-4.3.06-12.93.16-17.23.19l-17.23.07.5-.5,0,11.19-.45-.45,8.54,0c5.46.06,20.27.31,25.92.41Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.05,371.9c-5.74.1-20.22.35-25.77.41l-8.69.05h-.46v-.46l0-11.19v-.5h.51l17.23.07c4.29,0,12.94.13,17.23.19h.24v.24l-.24,11.19Zm0,0-.24-11.19.24.24c-4.3.06-12.94.16-17.23.19l-17.23.07.5-.5L60,371.9l-.45-.45,8.53,0c5.46.06,20.28.31,25.93.41Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.52,119c-5.74.1-20.21.35-25.76.41l-8.7.05h-.45V119l-.05-11.19v-.5h.5l17.23.07c4.29,0,12.94.13,17.23.19h.25v.23L292.52,119Zm0,0-.24-11.19.24.24c-4.3.07-12.93.16-17.23.2l-17.23.06.5-.5,0,11.19-.46-.45,8.54,0c5.46.07,20.27.32,25.92.41Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.3,133.08c-5.74.1-20.22.35-25.77.41l-8.69,0h-.45v-.46l0-11.19v-.5h.5l17.23.07c4.29,0,12.94.13,17.23.19h.25v.23l-.24,11.19Zm0,0-.24-11.19.24.24c-4.3.06-12.93.16-17.23.2l-17.23.06.5-.5-.05,11.19-.45-.45,8.54,0c5.46.07,20.27.32,25.92.41Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.29,
    y: 121.89,
    width: 34.46,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 640.07,
    y: 360.71,
    width: 34.46,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 640.07,
    y: 43.24,
    width: 34.46,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.75,68.54c-5.74.1-20.22.35-25.76.41l-8.7,0h-.45v-.46l-.05-11.19v-.5h.5l17.23.07c4.29,0,12.94.13,17.23.19H694v.23l-.24,11.19Zm0,0-.24-11.19.24.24c-4.3.07-12.93.16-17.23.2l-17.23.06.5-.5,0,11.19-.46-.45,8.54,0c5.46.07,20.27.32,25.92.41Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.71,54.45c-5.74.1-20.22.34-25.77.41l-8.69,0h-.46v-.45l0-11.19v-.51h.5l17.23.06c4.29,0,12.94.13,17.23.19H91v.24l-.24,11.19Zm0,0-.24-11.19.24.24c-4.3.06-12.93.15-17.23.19l-17.23.06.5-.49,0,11.19L56.25,54l8.53,0c5.47.07,20.28.32,25.93.42Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 384.17,
    y: 310.43,
    width: 34.46,
    height: 11.19,
    transform: "translate(802.8 632.05) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.39,296.32c5.75-.1,20.22-.35,25.77-.41l8.69,0h.46v.46l0,11.19v.5h-.51l-17.23-.07c-4.29,0-12.94-.13-17.23-.19h-.24v-.24l.24-11.19Zm0,0,.25,11.19-.25-.24c4.3-.06,12.94-.15,17.23-.19l17.23-.07-.49.5,0-11.19.45.46-8.53,0c-5.46-.06-20.28-.31-25.93-.41Z",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-179"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.61,433.06c212.31-.61,450.47-.62,662.78,0-212.31.62-450.47.61-662.78,0Z",
    style: {
      fill: "#263238"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Text--inject-179"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M267,465.83v-9.59a.88.88,0,0,1,.9-.89h5.31a.9.9,0,0,1,.89.89.91.91,0,0,1-.89.91h-4.4v3h3.78a.91.91,0,0,1,.9.89.9.9,0,0,1-.9.91h-3.78v3h4.4a.91.91,0,0,1,0,1.81H267.9s0,0,0,0v0A.9.9,0,0,1,267,465.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.44,465.38a.89.89,0,0,1-.57,1.13,1.33,1.33,0,0,1-.36.05h0a1.15,1.15,0,0,1-.63-.18,1.65,1.65,0,0,1-.52-.56,4.37,4.37,0,0,1-.34-1.95,1.35,1.35,0,0,0-.2-.7,1.44,1.44,0,0,0-.48-.47,3,3,0,0,0-.91-.39h-1.92v3.52a.91.91,0,0,1-.91.9.9.9,0,0,1-.9-.9v-9.59a.88.88,0,0,1,.9-.89h2.91a3.47,3.47,0,0,1,3.47,3.49,3.43,3.43,0,0,1-1.26,2.67,2.73,2.73,0,0,1,.57.6,3.11,3.11,0,0,1,.53,1.76,4.49,4.49,0,0,0,.07.95A.91.91,0,0,1,284.44,465.38Zm-2.28-6.54a1.68,1.68,0,0,0-1.67-1.69h-2v3.35h2A1.67,1.67,0,0,0,282.16,458.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.59,465.38a.89.89,0,0,1-.57,1.13,1.21,1.21,0,0,1-.36.05h0a1.18,1.18,0,0,1-.64-.18,1.65,1.65,0,0,1-.52-.56,4.52,4.52,0,0,1-.34-1.95,1.35,1.35,0,0,0-.19-.7,1.48,1.48,0,0,0-.49-.47,2.91,2.91,0,0,0-.91-.39h-1.92v3.52a.9.9,0,0,1-.91.9.89.89,0,0,1-.89-.9v-9.59a.88.88,0,0,1,.89-.89h2.91a3.47,3.47,0,0,1,2.21,6.16,2.52,2.52,0,0,1,.57.6,3,3,0,0,1,.54,1.76,4.06,4.06,0,0,0,.06.95A.91.91,0,0,1,294.59,465.38Zm-2.27-6.54a1.68,1.68,0,0,0-1.68-1.69h-2v3.35h2A1.67,1.67,0,0,0,292.32,458.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.92,456.76a6,6,0,0,1,0,8.23,5.35,5.35,0,0,1-3.89,1.74,5.51,5.51,0,0,1-4-1.74,6.06,6.06,0,0,1,0-8.23,5.42,5.42,0,0,1,4-1.73A5.27,5.27,0,0,1,305.92,456.76Zm-.22,4.12a4.2,4.2,0,0,0-1.1-2.85,3.51,3.51,0,0,0-5.2,0,4.16,4.16,0,0,0-1.11,2.85,4.07,4.07,0,0,0,1.11,2.82,3.47,3.47,0,0,0,5.2,0A4.11,4.11,0,0,0,305.7,460.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.28,465.38a.89.89,0,0,1-.57,1.13,1.21,1.21,0,0,1-.36.05h0a1.16,1.16,0,0,1-.64-.18,1.65,1.65,0,0,1-.52-.56,4.52,4.52,0,0,1-.34-1.95,1.35,1.35,0,0,0-.19-.7,1.58,1.58,0,0,0-.49-.47,2.91,2.91,0,0,0-.91-.39h-1.92v3.52a.9.9,0,0,1-.91.9.89.89,0,0,1-.89-.9v-9.59a.88.88,0,0,1,.89-.89h2.91a3.47,3.47,0,0,1,2.21,6.16,2.52,2.52,0,0,1,.57.6,3,3,0,0,1,.54,1.76,4.06,4.06,0,0,0,.06.95A.91.91,0,0,1,318.28,465.38ZM316,458.84a1.67,1.67,0,0,0-1.67-1.69h-2v3.35h2A1.66,1.66,0,0,0,316,458.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.17,461.75a1,1,0,0,1,1-1h3.05a1,1,0,0,1,0,1.93h-3.05A1,1,0,0,1,325.17,461.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.09,462.31h-2v3.52a.9.9,0,1,1-1.8,0v-9.59a.89.89,0,0,1,.89-.89h2.91a3.48,3.48,0,1,1,0,7Zm-2-1.81h2a1.68,1.68,0,1,0,0-3.35h-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.42,464h-3.94l-.8,2.12a.93.93,0,0,1-.85.57.94.94,0,0,1-.3-.05.92.92,0,0,1-.54-1.17l3.59-9.57a.9.9,0,0,1,.86-.57.87.87,0,0,1,.86.57l3.59,9.57a.91.91,0,0,1-.53,1.17,1,1,0,0,1-.31.05.89.89,0,0,1-.83-.57Zm-.66-1.78-1.32-3.5-1.31,3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.1,460.89a5.91,5.91,0,0,1,6-5.86,6.06,6.06,0,0,1,3.71,1.26.93.93,0,1,1-1.14,1.46,4.25,4.25,0,0,0-2.57-.87,4,4,0,0,0-2.92,1.18,3.86,3.86,0,0,0,0,5.63,4,4,0,0,0,2.92,1.18,4.54,4.54,0,0,0,2.23-.61V462H361a.93.93,0,0,1-.92-.93.91.91,0,0,1,.92-.91h3.24a.91.91,0,0,1,.94.91v3.59a1.16,1.16,0,0,1-.05.28.26.26,0,0,1,0,.08v0a.85.85,0,0,1-.31.39,6,6,0,0,1-3.69,1.27A5.91,5.91,0,0,1,355.1,460.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.82,465.83v-9.59a.88.88,0,0,1,.9-.89H375a.91.91,0,0,1,.9.89.92.92,0,0,1-.9.91h-4.4v3h3.78a.91.91,0,0,1,.9.89.9.9,0,0,1-.9.91h-3.78v3H375a.91.91,0,0,1,0,1.81h-5.26s0,0,0,0v0A.9.9,0,0,1,368.82,465.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.12,465.83a.91.91,0,0,1-.88.9.89.89,0,0,1-.89-.9v-9.46a.84.84,0,0,1,.36-.74.88.88,0,0,1,1.23.19l5.25,7.27v-6.7a.89.89,0,0,1,1.77,0v9.44a.9.9,0,0,1-.89.9.89.89,0,0,1-.67-.33.39.39,0,0,1-.08-.1l-5.2-7.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404,456.76a6,6,0,0,1,0,8.23,5.35,5.35,0,0,1-3.89,1.74,5.52,5.52,0,0,1-4-1.74,6.06,6.06,0,0,1,0-8.23,5.44,5.44,0,0,1,4-1.73A5.27,5.27,0,0,1,404,456.76Zm-.21,4.12A4.21,4.21,0,0,0,402.7,458a3.51,3.51,0,0,0-5.2,0,4.16,4.16,0,0,0-1.1,2.85,4.06,4.06,0,0,0,1.1,2.82,3.47,3.47,0,0,0,5.2,0A4.12,4.12,0,0,0,403.81,460.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.92,457.15h-2.58v8.68a.88.88,0,0,1-.9.9.89.89,0,0,1-.89-.9v-8.68H408a.9.9,0,0,1-.89-.91.88.88,0,0,1,.89-.89h6.94a.89.89,0,0,1,.89.89A.91.91,0,0,1,414.92,457.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.37,465.83v-9.59a.89.89,0,0,1,.89-.89h5.32a.9.9,0,0,1,0,1.8h-4.41v3H429a.9.9,0,0,1,0,1.8h-3.79v3.9a.9.9,0,0,1-.91.9A.89.89,0,0,1,423.37,465.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.84,456.76a6,6,0,0,1,0,8.23,5.33,5.33,0,0,1-3.88,1.74,5.51,5.51,0,0,1-4-1.74,6.06,6.06,0,0,1,0-8.23,5.42,5.42,0,0,1,4-1.73A5.25,5.25,0,0,1,441.84,456.76Zm-.21,4.12a4.25,4.25,0,0,0-1.1-2.85,3.51,3.51,0,0,0-5.2,0,4.12,4.12,0,0,0-1.11,2.85,4,4,0,0,0,1.11,2.82,3.47,3.47,0,0,0,5.2,0A4.16,4.16,0,0,0,441.63,460.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.67,466.73A4.69,4.69,0,0,1,446,462v-5.79a.88.88,0,0,1,.89-.89.9.9,0,0,1,.91.89V462a2.9,2.9,0,0,0,5.79,0v-5.79a.89.89,0,0,1,.91-.89.88.88,0,0,1,.89.89V462A4.7,4.7,0,0,1,450.67,466.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.72,465.83a.89.89,0,1,1-1.77,0v-9.46a.84.84,0,0,1,.36-.74.88.88,0,0,1,1.23.19l5.25,7.27v-6.7a.89.89,0,0,1,1.77,0v9.44a.9.9,0,0,1-.89.9.89.89,0,0,1-.67-.33.39.39,0,0,1-.08-.1l-5.2-7.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.65,465.83v-9.59a.88.88,0,0,1,.89-.89h1.92a5.69,5.69,0,0,1,0,11.38h-1.92A.89.89,0,0,1,470.65,465.83Zm1.8-.91h1a3.89,3.89,0,0,0,0-7.77h-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.15,462.81v-6.57a.91.91,0,0,1,.9-.89.88.88,0,0,1,.87.89v6.57a.87.87,0,0,1-.87.89A.89.89,0,0,1,482.15,462.81Zm.9,3.92a.9.9,0,0,1-.9-.9v-.32a.91.91,0,0,1,.9-.9.88.88,0,0,1,.87.9v.32A.87.87,0,0,1,483.05,466.73Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-4--inject-179"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M625.12,191.73l6.15,1a19.15,19.15,0,0,0,3.51-11.06c0-.91,1.43,4.5-.39,11.56,6.5,1,15.33,2.45,23.06,3.61.56-3,1.21-5.76,1.21-5.76a33.51,33.51,0,0,0,.47,6l3.08.45a118.89,118.89,0,0,1,2.32-12.79,41.59,41.59,0,0,0,2.08,13.43c4.91.68,8.16,1,8,.78-6.28-9.53-.17-13.7-1.26-21.5-1.32-9.34-8.88-11.82-7.74-18.55.92-5.47,3-15.35-3.7-18.43a13.51,13.51,0,0,0-14.14-4.75c-11.55,2.72-9.5,20.26-10.72,23.61-1.73,4.78-4.31,6.2-6.83,11.58s-.48,9.57-.71,13.47S623.89,191.55,625.12,191.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675,197.76a19.41,19.41,0,0,1-1.73-5.13,10.15,10.15,0,0,1,.72-5.16,52.07,52.07,0,0,0,1.64-5.31,14.38,14.38,0,0,0,.23-5.74,12.78,12.78,0,0,0-2.3-5.28A34.62,34.62,0,0,0,669.8,167a20.36,20.36,0,0,1-3.42-4.15,9.93,9.93,0,0,1-1.3-5.18,9.35,9.35,0,0,0,.7,5.48,18.86,18.86,0,0,0,3.22,4.59,41.53,41.53,0,0,1,3.43,4.18,12.12,12.12,0,0,1,2,4.76,14.42,14.42,0,0,1-.18,5.19c-.34,1.75-.91,3.47-1.39,5.27a17.88,17.88,0,0,0-.56,2.77,7.94,7.94,0,0,0,.24,2.88A15.67,15.67,0,0,0,675,197.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.69,141.19a27.48,27.48,0,0,0-2.39,6.35c-.58,2.2-1,4.41-1.5,6.62l-.69,3.3a17.26,17.26,0,0,1-.93,3.11,18,18,0,0,1-3.77,5.28,24.2,24.2,0,0,0-2.19,2.69,15.35,15.35,0,0,0-1.67,3.12,23.69,23.69,0,0,0-.95,3.36,14.65,14.65,0,0,0-.28,3.5c0,1.17.22,2.3.35,3.4a16.48,16.48,0,0,1,.07,3.29,6.89,6.89,0,0,1-3.46,5.31,7,7,0,0,0,4.16-5.21,17.46,17.46,0,0,0,.18-3.46c0-1.15-.18-2.26-.16-3.35a18,18,0,0,1,1.38-6.33,16,16,0,0,1,1.55-2.81,26,26,0,0,1,2.11-2.53,32.22,32.22,0,0,0,2.22-2.64,13.8,13.8,0,0,0,1.74-3.09,18.22,18.22,0,0,0,.91-3.38c.22-1.12.39-2.24.56-3.35.35-2.23.67-4.46,1.08-6.67A32.62,32.62,0,0,1,640.69,141.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.88,178.59c-8.51,5.48-43.68,8.67-52.16,4.73-12.63-5.86-26.29-20-30.83-25.62-2-2.43,18.68-16,21.15-13.75,5.3,4.85,15.22,17.7,17.46,18.82s22.22,5.32,33.14,6.32C654.3,170.43,655.19,175.82,650.88,178.59Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574,164.41c-1.26-.93-11.91-7.49-15.58-13.31-1.95-3.08-6.34-12.15-4.61-13.57s3.39.89,3.39.89-1.9-4.07.31-5.84,5.09,2.08,5.09,2.08-1.65-4.33.69-5.94,4.57,2.75,4.57,2.75-1.69-3.88.79-4.4c3-.63,5.28,6.89,8,9.87.61.67,13.5,12.81,13.5,12.81Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568,131.48c1.71,5.52,3.41,7.64,7.73,11.34.08.07,0,.21-.1.15-4.56-3.24-7.08-5.59-7.9-11.43C567.7,131.26,567.93,131.21,568,131.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.75,134.64c2.28,5.58,4.1,7.9,8.34,12.11.06.06,0,.17-.1.11-4.5-3.78-7-6.18-8.5-12.06C562.42,134.54,562.65,134.39,562.75,134.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.4,138.62c2.59,5.25,4.48,7.87,9.13,11.43a.11.11,0,0,1-.12.18c-5.09-3.17-7.48-6.43-9.16-11.51C557.14,138.37,557.24,138.29,557.4,138.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.8,150s-3-6.57-5-9.17-12.87-9.56-14.51-7.29c-2.11,2.93,3.39,8.19,6.42,10.42,0,0-4.9,6.77-1.77,11.4S594.8,150,594.8,150Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575,134.57c0,4.06,4.17,6.72,6.95,9.1a.34.34,0,0,1,0,.55c-1.86,3-3.63,7.72-2.17,11.13a.09.09,0,0,1-.15.08c-2.06-3.45-.71-8.25,1.54-11.38-2.88-2.39-7-5.24-6.18-9.48C574.93,134.54,575,134.54,575,134.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.86,166.38l-6.26,19.54s22.23-3.87,28.45-6.85c7-3.36,3.75-6.2-3.19-8.71S628.86,166.38,628.86,166.38Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627,184.28c.32-.64,2.37-6.7,2.79-8s2.17-6.73,2.48-8.13c0-.07-.06-.1-.09,0-.57,1.32-2.36,6.76-2.81,8.11s-2.35,7.38-2.46,8.07C626.85,184.32,626.93,184.33,627,184.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.05,179.06c-6.22,3-28.46,6.86-28.46,6.86l2-6.36c5.53-2.36,15.87-6.9,22-9.6.41.13.81.26,1.19.4C654.81,172.87,658.05,175.71,651.05,179.06Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.57,221.18s-18.18,91.28-19.46,98c-.29,1.54.76,83.24.76,83.24H604.09s-3.26-71.37-1.63-84.83,22.22-96.43,22.22-96.43Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.57,221.18l-14.64,73.58-17.26-73.58Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "613.22 266.82 649.13 271.14 656.57 221.18 624.68 221.18 613.22 266.82",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.79,264.24c-3.84-.76-7.73-1.24-11.62-1.68s-7.7-.85-11.55-1.25c-2.21-.22-4.42-.44-6.63-.56-.15,0-.16.18,0,.21,3.84.71,7.74,1.16,11.62,1.67s7.68,1,11.54,1.4c2.21.24,4.41.42,6.63.51A.15.15,0,1,0,647.79,264.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.6,224.09q-4,14.35-7.64,28.8c-.34,1.35-.67,2.7-1,4.06a40.05,40.05,0,0,0-.9,4.19.06.06,0,0,0,.12,0,69.52,69.52,0,0,0,2.1-7.23c.65-2.39,1.26-4.79,1.88-7.18,1.24-4.79,2.47-9.58,3.63-14.39.67-2.75,1.33-5.49,2-8.24A.09.09,0,0,0,651.6,224.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.1,433.4c1.86.62,55.13.47,57.16-.82.77-.48,1.2-8.25,1.45-17.64.06-2,.1-4.11.13-6.25,0-2.51.07-5.07.09-7.54.07-11.13-.34-20.92-.34-20.92H603.16l0,20.92v7.54l.18,6.25s-20.37,9.19-22.44,10.84S577.24,432.79,579.1,433.4Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.1,433.4c1.86.62,55.13.47,57.16-.82.77-.48,1.2-8.25,1.45-17.64.06-2,.1-4.11.13-6.25,0-2.51.07-5.07.09-7.54H603.18v7.54l.18,6.25s-20.37,9.19-22.44,10.84S577.24,432.79,579.1,433.4Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.94,433.48c1.21.4,23.9.49,40.42.14,3.82-.08,7.32-.18,10.14-.31,3.88-.18,6.49-.39,6.92-.66.93-.6,1.38-12,1.59-24H603.17l.17,6.28s-20.48,9.23-22.56,10.9S577.07,432.86,578.94,433.48Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.7,431.34c9-.25,45.21-.39,54.11,0,.07,0,.07.06,0,.06-8.9.44-45.13.29-54.11.05C579.51,431.48,579.51,431.34,579.7,431.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.07,412.93c3.53-.67,7.85-.14,10.56,2.37.11.1,0,.24-.15.21a49,49,0,0,0-10.39-2.13A.23.23,0,0,1,602.07,412.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.52,414.47c3.54-.67,7.86-.14,10.57,2.37.1.1,0,.25-.15.21a49.76,49.76,0,0,0-10.4-2.13A.23.23,0,0,1,599.52,414.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597,416c3.53-.67,7.85-.14,10.56,2.37.11.09,0,.24-.15.21a49.78,49.78,0,0,0-10.4-2.14A.22.22,0,0,1,597,416Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.43,417.56c3.53-.67,7.86-.14,10.56,2.37.11.1,0,.25-.15.21A49.54,49.54,0,0,0,594.45,418,.23.23,0,0,1,594.43,417.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.12,409.8c2.5,1.94,5.76,2.72,8.68,3.8.3.11.54-.18.55-.45.06,0,.11,0,.09-.12A19,19,0,0,0,601,405c-1.48-1.24-4.07-2.09-5.45-.17S595.66,408.67,597.12,409.8Zm-.91-2.84c-.63-3.87,3.54-1.85,4.59-.89a21,21,0,0,1,1.88,2c1.23,1.47,2.22,3.08,3.29,4.65-1.4-.61-2.84-1.1-4.27-1.66C600,410.4,596.56,409.1,596.21,407Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.22,407.61c-.86-2.2-3.58-2-5.32-1.2a18.84,18.84,0,0,0-7.31,6.46.1.1,0,0,0,0,.15c-.06.26.1.6.42.56,3.1-.31,6.44-.25,9.35-1.5C617.11,411.35,619,409.69,618.22,407.61Zm-7.56,4.54c-1.52.19-3,.31-4.55.55,1.43-1.25,2.8-2.56,4.35-3.68a19.38,19.38,0,0,1,2.32-1.48c1.26-.66,5.8-1.58,4.22,2C616.13,411.53,612.47,411.93,610.66,412.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.91,413.56c-.24,10-.69,18.57-1.49,19.09-.43.27-3,.49-6.92.66-2.83.13-6.32.23-10.14.31-2.46.06-5.06.1-7.69.12Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646.92,398.24l34.72-.44s-6.82-118.48-9.79-143.14c0,0,5.63-13.35-4.91-33.51h-42.3s2.84,19.19,7.69,31.35a45.5,45.5,0,0,1,8.85,4Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.8,271.4H675l-2.53-16.74s5-17-4.82-33.51h-43s1.79,18,7.07,31.54l5.4,2.39Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.11,255.08c0-.21-.47-.2-.43,0,1.75,9.87,4.51,14.65,4.71,15.1a.06.06,0,0,0,.12,0C641.67,269.72,637.9,259.18,637.11,255.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.73,252a69.56,69.56,0,0,1,11,5.12c.14.08,0,.3-.1.23-3.71-1.59-7.49-3.11-11.1-4.91A.24.24,0,0,1,630.73,252Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.55,226.57c0-.12.23-.15.23,0a123.75,123.75,0,0,0,.62,12.38c.18,1.92,1.71,12.47,5,11.7.56-.13.84-.67.93-1.51a13.37,13.37,0,0,0-.44-3.24c-.37-2.21-.66-4.42-.85-6.66a60.53,60.53,0,0,1,.13-12.48.11.11,0,0,1,.22,0,114.23,114.23,0,0,0,1,17.24c.42,2.74,1.8,6.88-1.07,7.3s-4.82-6.49-5.17-8.39A63,63,0,0,1,629.55,226.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.34,250.93a16.45,16.45,0,0,1,.74,2.18,4.88,4.88,0,0,1,.31,1.8c0,.12-.17.13-.23.05a6.39,6.39,0,0,1-.77-1.75c-.25-.68-.52-1.35-.75-2A.37.37,0,0,1,635.34,250.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.16,239.49c-3.13-.32-6.35-.28-9.25-1.67s-4.82-4.22-6.33-7a23.07,23.07,0,0,1-2.08-5.51.08.08,0,0,0-.15,0,15.05,15.05,0,0,0,1.28,5.19,23,23,0,0,0,2.48,4.61,11.2,11.2,0,0,0,3.57,3.35,12.21,12.21,0,0,0,4.7,1.42,26.69,26.69,0,0,0,5.79,0A.18.18,0,0,0,666.16,239.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.47,258.19a28.81,28.81,0,0,1-.93-4.67c-.09-1.57.74-2.92,1.21-4.37,1.84-5.62,1.1-11.77-.91-17.24a62.51,62.51,0,0,0-4.32-9c0-.08-.15,0-.11.06,2.74,5.35,5.16,11.07,5.7,17.11a22.87,22.87,0,0,1-.81,8.67,20.56,20.56,0,0,0-1.28,4,14.51,14.51,0,0,0,.69,4.37c.4,1.75,1.63,7,2.16,8.81,0,.15.32.12.29-.05C671.92,264.31,670.83,259.81,670.47,258.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672.86,267.07c-3.9-.29-7.83-.29-11.74-.25s-7.74.1-11.62.18c-2.21.05-4.44.1-6.65.25a.11.11,0,1,0,0,.21c3.9.24,7.83.21,11.74.24s7.75,0,11.62,0c2.22,0,4.43-.12,6.65-.3A.15.15,0,1,0,672.86,267.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.49,433.6c1.86.64,55.12,1,57.16-.26.77-.47,1.28-8.23,1.63-17.62q.12-3,.19-6.25c.07-2.52.13-5.07.17-7.54a142.72,142.72,0,0,0-1.56-21.86l-33,.59-.19,20.92-.07,7.55.12,6.25s-20.46,9-22.54,10.62S620.63,433,622.49,433.6Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.49,433.6c1.86.64,55.12,1,57.16-.26.77-.47,1.28-8.23,1.63-17.62q.12-3,.19-6.25c.07-2.52.13-5.07.17-7.54l-34.75-.35-.07,7.55.12,6.25s-20.46,9-22.54,10.62S620.63,433,622.49,433.6Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.32,433.68c1.21.41,23.9.72,40.42.54,3.83-.05,7.32-.12,10.15-.21,3.88-.14,6.49-.33,6.92-.59.94-.6,1.5-12,1.84-24l-34.85-.35.12,6.29s-20.57,9-22.68,10.67S620.46,433,622.32,433.68Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.11,431.54c9-.16,45.21.06,54.1.58.08,0,.08.06,0,.06-8.89.35-45.13-.16-54.1-.49C622.92,431.68,622.92,431.54,623.11,431.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.66,413.35c3.54-.63,7.86-.06,10.54,2.48.1.1,0,.24-.15.2a49.63,49.63,0,0,0-10.38-2.23A.23.23,0,0,1,645.66,413.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.1,414.87c3.54-.63,7.86-.06,10.54,2.48.1.09,0,.24-.15.2a49.63,49.63,0,0,0-10.38-2.23A.23.23,0,0,1,643.1,414.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.54,416.39c3.54-.63,7.85-.06,10.54,2.48.1.09,0,.24-.15.2a49.63,49.63,0,0,0-10.38-2.23A.23.23,0,0,1,640.54,416.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638,417.91c3.54-.63,7.85-.06,10.54,2.47.1.1,0,.25-.16.21A49.4,49.4,0,0,0,638,418.36.23.23,0,0,1,638,417.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.74,410.18c2.49,2,5.73,2.78,8.64,3.88a.44.44,0,0,0,.56-.44.1.1,0,0,0,.09-.13,19,19,0,0,0-5.39-8.13c-1.47-1.25-4-2.13-5.45-.22S639.29,409,640.74,410.18Zm-.88-2.85c-.59-3.88,3.55-1.82,4.6-.85a21,21,0,0,1,1.86,2c1.21,1.48,2.19,3.1,3.25,4.68-1.4-.62-2.84-1.13-4.26-1.7C643.62,410.8,640.19,409.47,639.86,407.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.86,408.19c-.84-2.21-3.56-2.05-5.31-1.24a18.79,18.79,0,0,0-7.37,6.38.1.1,0,0,0,.05.15.43.43,0,0,0,.42.57c3.09-.28,6.44-.2,9.36-1.42C660.72,411.92,662.65,410.28,661.86,408.19Zm-7.6,4.47c-1.52.18-3,.28-4.56.51a54.66,54.66,0,0,1,4.39-3.64,20.83,20.83,0,0,1,2.34-1.46c1.26-.65,5.81-1.52,4.19,2.06C659.73,412.1,656.07,412.46,654.26,412.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628,202.68l-3.34,18.5,43,0s.6-32.42-10.36-46.74c-5.48-7.16-10.29-6.58-15.27-2.38-1.26,1.06-13.73,13.89-15.82,20.69A10.65,10.65,0,0,0,628,202.68Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.58,201a34,34,0,0,1,5.69,1.93c.92.42,1.81.89,2.69,1.39.44.25.89.47,1.34.7a5.25,5.25,0,0,0,1.46.54s0,.09,0,.09a8.76,8.76,0,0,1-1.45-.23,8.34,8.34,0,0,1-1.34-.5c-.93-.41-1.84-.88-2.77-1.31-1.87-.86-3.73-1.72-5.66-2.42C634.44,201.14,634.49,201,634.58,201Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.45,202.44a36.51,36.51,0,0,1,4.91.37,24.68,24.68,0,0,1,2.42.49l1.14.32c.42.12.82.31,1.23.42.05,0,0,.1,0,.09-.4-.1-.81-.11-1.21-.18l-1.22-.2c-.81-.13-1.62-.25-2.42-.39-1.62-.28-3.24-.54-4.87-.76C629.34,202.59,629.36,202.44,629.45,202.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.11,172.23c-.35.85-5.44,5.87-9.41,5-1.3-.27-.13-7.4-.13-7.4l0-.55-.47-7.64,9.55-4.18L654,157s0,2.1,0,4.71c0,.12,0,.24,0,.37s0,.29,0,.43c0,.39,0,.79,0,1.19s0,.59,0,.91,0,.63,0,.95A48.92,48.92,0,0,1,653.11,172.23Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.06,161.68l.46,7.34a16.42,16.42,0,0,0,10.42-6.6v-.74c0-2.61,0-4.71,0-4.71l-1.36.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.91,145.91c-6.38,11.83,0,17,2.54,18.36,2.32,1.24,10.36,5.19,17.93-5.92s4.08-17.81-1.07-20.94S643.28,134.08,636.91,145.91Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.65,145a7.09,7.09,0,0,0,.91.22,1.5,1.5,0,0,0,1,0,.49.49,0,0,0,.25-.53,1.2,1.2,0,0,0-.94-.75,1.72,1.72,0,0,0-1.26.1A.5.5,0,0,0,639.65,145Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.9,148.89a6.54,6.54,0,0,1-.74-.56,1.49,1.49,0,0,1-.65-.71.48.48,0,0,1,.25-.53,1.2,1.2,0,0,1,1.18.25,1.7,1.7,0,0,1,.72,1A.51.51,0,0,1,647.9,148.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.12,150.25s0,.07,0,.1c-.43.81-.79,1.81-.19,2.45,0,0,0,.06,0,0C644.08,152.26,644.58,150.94,645.12,150.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646.27,149.76c1.37.56.16,3.25-1.11,2.73S645.13,149.29,646.27,149.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646.74,150.14c.16.26.27.63.54.79a1.1,1.1,0,0,0,1-.17s.05,0,0,.05c-.22.52-.66,1-1.25.79a1.11,1.11,0,0,1-.59-1.35C646.52,150.14,646.67,150,646.74,150.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.49,148s-.08,0-.1,0c-.36.84-.91,1.75-1.79,1.67a0,0,0,0,0,0,.05C639.56,150.1,640.28,148.89,640.49,148Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.15,146.82c-1.29-.72-2.63,1.91-1.44,2.58S641.23,147.43,640.15,146.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.52,146.72c-.28,0-.62.18-.88.07s-.36-.53-.4-.89c0,0,0,0-.06,0-.27.5-.37,1.11.06,1.45s.94.05,1.32-.39C639.63,146.88,639.63,146.7,639.52,146.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.41,156.82a1.38,1.38,0,0,1-.93.11,2.45,2.45,0,0,1-.76-.67,0,0,0,0,0-.06,0,1.26,1.26,0,0,0,.79,1,1,1,0,0,0,1-.37S641.45,156.81,641.41,156.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.83,154.8a3.08,3.08,0,0,1-2.44.19,4.28,4.28,0,0,1-1-.49,1.09,1.09,0,0,1-.17-.13,1.58,1.58,0,0,1-.15-.12A.2.2,0,0,1,639,154h0l.05-.07h0l0-.07c.32-.61.89-1.49.89-1.49-.29,0-1.69-.14-1.49-.44a46.1,46.1,0,0,1,5.53-7.47.08.08,0,0,1,.13.1c-1.45,2.47-3.33,4.68-4.83,7.15a4.89,4.89,0,0,1,1.47.32c.07.07-1.13,1.68-1.25,2a0,0,0,0,0,0,0,4.24,4.24,0,0,0,3.23.68C642.88,154.67,642.91,154.76,642.83,154.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.29,158.82c-3-1.6.71-11.38,1.18-12.57-.34.73-2.12,4.63-2.49,4.64a3.06,3.06,0,0,1-.86-.64h0a9.67,9.67,0,0,0,.56-1.43c.08-.23-.3.42-.83,1.2l-.48-.43a12.26,12.26,0,0,0,1.14-3.07c.09-.41-.81,1.18-1.86,2.44a40.37,40.37,0,0,0-7.27-5.31c-.75-.4-1.41-.71-2-1,.55-1.14,1.28-2.28,1.07-2.06a11.91,11.91,0,0,0-1.51,1.87l-.9-.35c.71-1.65,2.73-3.83,2.28-3.57a12.7,12.7,0,0,0-3.49,3.19c-1.2-.32-1.61-.26-1.5-.55a14.93,14.93,0,0,1,8.14-6.31c5.56-1.71,13.59,1.11,15.16,8.72,0,0,2.39,4,1.13,8S658,159.74,656.29,158.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655,158.25s4.36-2.69,5.69-1-3.11,6.43-5.49,6.3a2.27,2.27,0,0,1-2.31-2.33Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.39,158.59s0,.06,0,.06a5.75,5.75,0,0,0-4.15,2.12,1.25,1.25,0,0,1,1.86.43s0,.09-.07.06a1.41,1.41,0,0,0-1.61-.16,6.47,6.47,0,0,0-1.17.85c-.12.1-.32-.07-.21-.2l0,0C654.81,159.88,657.34,157.92,659.39,158.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654,162.4a.66.66,0,0,0,.34.87.66.66,0,1,0-.34-.87Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.76,188.22c-.08,7.16-.65,32.5-6.38,39.52-3.73,4.57-31.89,13.83-39.11,15.32-3,.63-10.57-20.62-7.28-20.8,2.43-.13,29.76-7.32,32-8.33L649.68,187C654,176,659.89,176.22,659.76,188.22Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.33,226.3c1.24-.77.84-1.43-1.75-1.71s-13.05.8-13.12-2.88,14.73-5,19-4.21a68.79,68.79,0,0,1,10.9,3.59C610.52,221.92,603.85,224.6,598.33,226.3Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.16,242.46c-8,2-17.95,5.1-26.95,2.49a4.64,4.64,0,0,1-2.53-1.69c-4-1.1-4.75-3.34-4.75-3.34-3.47-2.18-3.87-4.58-3.87-4.58s-4.75-1.34-4.41-4.34c.36-3.37,7-.83,11.44-1.65,10.28-1.88,24.35-7.43,27.26-8.26Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.24,234.94a66.08,66.08,0,0,1-9.08,1.14,66.88,66.88,0,0,1-10-.81c-.11,0-.14.14,0,.16a35.49,35.49,0,0,0,19.15-.35C598.41,235,598.39,234.92,598.24,234.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.28,241c-3,.32-8.22.84-17.33-1.16,0,0-.05,0,0,.05a31.8,31.8,0,0,0,17.36,1.25C600.48,241.09,600.48,241,600.28,241Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.31,244.24a49.71,49.71,0,0,1-13.6-1s-.05,0,0,.06c5.88,1.67,8.2,1.61,13.66,1.12C601.53,244.4,601.51,244.23,601.31,244.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.35,200.74l18,9.91s.48-22.57-1.26-29.25c-1.94-7.51-5.36-4.87-9.15,1.46S642.35,200.74,642.35,200.74Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.56,206.06c-.57-.44-6.12-3.61-7.34-4.28s-6.2-3.42-7.51-4c-.06,0-.11,0-.06.09,1.18.82,6.19,3.62,7.42,4.32s6.79,3.72,7.45,4C659.58,206.17,659.6,206.09,659.56,206.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.78,201.51c-.52-.33-1.35-.83-1.35-.83.72-2.27,5.39-13.42,6.47-16.13,0-.05,0-.07-.06,0-.71,1.5-1.41,3-2.1,4.49,0-.2.1-.41.16-.61.19-.72.36-1.44.57-2.15,0-.06-.07-.1-.09,0a16.17,16.17,0,0,0-.72,2.13c-.13.51-.22,1-.31,1.55-.39.86-.78,1.72-1.15,2.6-1.13,2.68-2.4,5.42-3.31,8.19a10.42,10.42,0,0,0,1.84,1C643.82,201.67,643.86,201.56,643.78,201.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.59,209.69c.61.25,1.21.54,1.82.81l-.24.13c0-4.79-.07-11.51.09-16.23q.32,2,.45,4a63.39,63.39,0,0,1-.25,12.47c-.62-.41-1.26-.8-1.87-1.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.48,199.52a10.34,10.34,0,0,1,.63-3.21,3.69,3.69,0,0,1-.63,3.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633.5,64l8.77,8.58.1.1-8.77-8.57Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.53,220.7l-8.77-8.58c.11.12.23.23.34.33l8.78,8.58Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "603.22 120.96 612 129.54 547.01 196.17 538.24 187.59 603.22 120.96",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "603.22 120.96 612 129.54 547.01 196.17 538.24 187.59 603.22 120.96"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M600.42,232.19l-89.62-6.91c-1.06-.09-1.54-.14-2-.22a13.17,13.17,0,0,1-7.41-3.53L492.58,213a13.16,13.16,0,0,0,7.42,3.53c.48.08,1,.13,2,.22l89.63,6.91Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M600.42,232.19l-89.62-6.91c-1.06-.09-1.54-.14-2-.22a13.17,13.17,0,0,1-7.41-3.53L492.58,213a13.16,13.16,0,0,0,7.42,3.53c.48.08,1,.13,2,.22l89.63,6.91Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M635.48,203l-8.77-8.58L639.8,78.25c0-.29.07-.58.1-.88.07-.57-.19-.88-.12-1.45a3.2,3.2,0,0,0-.09-1.75c0-.29-.2-.88-.15-1.17a13.57,13.57,0,0,0-.39-1.77,2.14,2.14,0,0,1-.44-1.2,8.08,8.08,0,0,0-1-1.52c-.26-.31-.48-.9-.74-1.21s-.51-.62-1-1.24a.36.36,0,0,0-.1-.26l8.69,8.49c.13.12.2.23.18.34.51.61.77.93,1,1.24s.49.91.74,1.22a8.49,8.49,0,0,1,1,1.52,2.17,2.17,0,0,0,.43,1.2,10.67,10.67,0,0,1,.39,1.77c0,.28.19.88.15,1.17a3.07,3.07,0,0,1,.09,1.74c-.06.58.19.89.13,1.46,0,.29-.07.59-.1.87Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M635.48,203l-8.77-8.58L639.8,78.25c0-.29.07-.58.1-.88.07-.57-.19-.88-.12-1.45a3.2,3.2,0,0,0-.09-1.75c0-.29-.2-.88-.15-1.17a13.57,13.57,0,0,0-.39-1.77,2.14,2.14,0,0,1-.44-1.2,8.08,8.08,0,0,0-1-1.52c-.26-.31-.48-.9-.74-1.21s-.51-.62-1-1.24a.36.36,0,0,0-.1-.26l8.69,8.49c.13.12.2.23.18.34.51.61.77.93,1,1.24s.49.91.74,1.22a8.49,8.49,0,0,1,1,1.52,2.17,2.17,0,0,0,.43,1.2,10.67,10.67,0,0,1,.39,1.77c0,.28.19.88.15,1.17a3.07,3.07,0,0,1,.09,1.74c-.06.58.19.89.13,1.46,0,.29-.07.59-.1.87Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M652.61,220.27a16.57,16.57,0,0,1-17.82,14.58l-2.87-.23L623.15,226l2.86.23a16.54,16.54,0,0,0,17.82-14.57A15.27,15.27,0,0,0,639.32,199l8.77,8.58A15.26,15.26,0,0,1,652.61,220.27Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M652.61,220.27a16.57,16.57,0,0,1-17.82,14.58l-2.87-.23L623.15,226l2.86.23a16.54,16.54,0,0,0,17.82-14.57A15.27,15.27,0,0,0,639.32,199l8.77,8.58A15.26,15.26,0,0,1,652.61,220.27Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M629.47,256.49a16.33,16.33,0,0,1-17.54,14.6c-.44,0-.85-.09-1.28-.16a15.21,15.21,0,0,1-8.33-4.1l-8.77-8.58a15.12,15.12,0,0,0,8.33,4.11c.42.06.84.11,1.27.15a16.32,16.32,0,0,0,17.54-14.6L623.15,226l8.77,8.58Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M629.47,256.49a16.33,16.33,0,0,1-17.54,14.6c-.44,0-.85-.09-1.28-.16a15.21,15.21,0,0,1-8.33-4.1l-8.77-8.58a15.12,15.12,0,0,0,8.33,4.11c.42.06.84.11,1.27.15a16.32,16.32,0,0,0,17.54-14.6L623.15,226l8.77,8.58Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M643.84,211.7A16.56,16.56,0,0,1,626,226.27l-2.86-.22-2.46,21.86a16.32,16.32,0,0,1-17.54,14.6c-.43,0-.85-.09-1.27-.15a15,15,0,0,1-12.69-16.88l2.46-21.86L502,216.7c-1-.08-1.54-.14-2-.21a13.15,13.15,0,0,1-7.9-4c-6.54-6-6.3-15.86-.08-22.33L612.87,66c.29,0,.33-.27.65-.54a4.26,4.26,0,0,0,1-1.08,3.12,3.12,0,0,0,1.53-.76c.32-.26.93-.51,1.24-.77a3.11,3.11,0,0,1,1.79-.44c.35-.56.67-.82,1.24-.77.32-.27.89-.22,1.78-.45a1.74,1.74,0,0,0,1.18-.2l2,.16.58,0,.57,0,1.72.14a2.12,2.12,0,0,0,.89.34c.77.37,1.62.43,2.16.77a12,12,0,0,1,2.42,1.63c.54.33.79.64,1.33,1s1.08.67,1.05,1c.51.61.76.93,1,1.23s.48.91.74,1.22a8.08,8.08,0,0,1,1,1.52,2.09,2.09,0,0,0,.44,1.2,12.26,12.26,0,0,1,.38,1.77c0,.29.19.89.15,1.18a3.14,3.14,0,0,1,.1,1.74c-.07.57.19.88.12,1.46,0,.29-.06.58-.1.86L626.71,194.42l2.87.22c.41,0,.83.08,1.23.14A15.39,15.39,0,0,1,643.84,211.7ZM538.23,187.59l57,4.4,8-71-65,66.63",
    style: {
      fill: "#FFC727"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-3--inject-179"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M426.4,113.83a21.23,21.23,0,0,0-8.52-3.82,19.68,19.68,0,0,0-4.89-.64c-7.54-.08-16.26,3.81-25.31,12-10.87,10.41-20.95,27-26.13,47.33-5.11,20.09-4.16,39.47.58,53.11,3.32,9.36,7.89,15.8,13.13,19.62l-9.91-7.23c-5.24-3.82-9.83-10.25-13.13-19.62-4.75-13.64-5.69-33-.59-53.1,5.18-20.37,15.27-36.93,26.14-47.34,9-8.2,17.76-12.09,25.3-12a19.62,19.62,0,0,1,4.89.64,21.33,21.33,0,0,1,8.53,3.82Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M426.4,113.83a21.23,21.23,0,0,0-8.52-3.82,19.68,19.68,0,0,0-4.89-.64c-7.54-.08-16.26,3.81-25.31,12-10.87,10.41-20.95,27-26.13,47.33-5.11,20.09-4.16,39.47.58,53.11,3.32,9.36,7.89,15.8,13.13,19.62l-9.91-7.23c-5.24-3.82-9.83-10.25-13.13-19.62-4.75-13.64-5.69-33-.59-53.1,5.18-20.37,15.27-36.93,26.14-47.34,9-8.2,17.76-12.09,25.3-12a19.62,19.62,0,0,1,4.89.64,21.33,21.33,0,0,1,8.53,3.82Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M471.17,193.66c-6.83,25.69-19.26,48-36.08,63.33-13.36,12.52-30.34,21.16-48.19,21a54,54,0,0,1-11.41-1.34,52.13,52.13,0,0,1-19.15-8.77l-9.91-7.23a52,52,0,0,0,19.15,8.77A53.82,53.82,0,0,0,377,270.76c17.85.17,34.83-8.48,48.19-21,16.81-15.33,29.24-37.64,36.08-63.33,6.34-26.08,5.93-51-1.67-71.9-4.67-13.73-12.65-26-23.87-34.15l9.92,7.22c11.21,8.17,19.19,20.42,23.86,34.16C477.1,142.64,477.51,167.57,471.17,193.66Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M471.17,193.66c-6.83,25.69-19.26,48-36.08,63.33-13.36,12.52-30.34,21.16-48.19,21a54,54,0,0,1-11.41-1.34,52.13,52.13,0,0,1-19.15-8.77l-9.91-7.23a52,52,0,0,0,19.15,8.77A53.82,53.82,0,0,0,377,270.76c17.85.17,34.83-8.48,48.19-21,16.81-15.33,29.24-37.64,36.08-63.33,6.34-26.08,5.93-51-1.67-71.9-4.67-13.73-12.65-26-23.87-34.15l9.92,7.22c11.21,8.17,19.19,20.42,23.86,34.16C477.1,142.64,477.51,167.57,471.17,193.66Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M459.58,114.52c7.61,20.89,8,45.83,1.68,71.91-6.84,25.69-19.27,48-36.08,63.33-13.36,12.52-30.34,21.17-48.19,21a54,54,0,0,1-11.42-1.34c-21.37-4.86-36.23-22.6-43.35-43.08-7.33-20.82-8-46.1-1.4-71.85,6.63-26,19.26-48,35.81-63.39,13.41-12.75,30.54-21.2,48.13-21A52.82,52.82,0,0,1,416,71.38C437.88,76.37,452.53,93.77,459.58,114.52Zm-29.13,64.91c5.18-20.37,4.16-39.46-.51-53.39-5.31-13.78-13.31-21.58-22-23.26a20.1,20.1,0,0,0-4.89-.64c-7.54-.07-16.26,3.82-25.3,12-10.88,10.4-21,27-26.14,47.33-5.11,20.08-4.16,39.46.59,53.11,4.94,14,12.73,21.45,21.34,23.41a22.48,22.48,0,0,0,4.7.54c7.7.07,16.7-3.6,26.13-12.08,10.79-10.12,20.95-27,26.06-47",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.48,281.69s-7.09,1-9.74,6.35-14.93,33.53-17.39,39-23.44,30.68-23.44,30.68,6.9,9.31,9,11.3c2.91,2.76,14,7.89,14,7.89s14.35-39.62,15.73-43.74S485.48,281.69,485.48,281.69Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.93,346.37a3.3,3.3,0,0,0-2.93,1,10.52,10.52,0,0,0-3.13,3.42c-.41.75-.86,2,.14,2.46s2.61-.65,3.41-1.23S460.6,347.05,457.93,346.37Zm-11.2.51c-1.54.07-2.66,1.77-3.27,3a9.6,9.6,0,0,0-1,3.18,2.73,2.73,0,0,0,.19,1.76c.81,1.38,2.08-.11,2.75-.83a9.84,9.84,0,0,0,2.72-4.69C448.29,348.19,448.17,346.81,446.73,346.88Zm12-8.41c-.65-.63-1.48-.38-2.25.19a8.75,8.75,0,0,0-2.29,2.43c-.34.59-.93,1.61-.5,2.3s1.38.43,2,.1C456.7,342.9,460.18,339.89,458.72,338.47Zm-13.38,31.7a13.29,13.29,0,0,1-1.43-1.12c-.21-.19-.45-.45-.73-.76l.25,0c.95-.14,1.79.05,2.06.93A1.06,1.06,0,0,1,445.34,370.17Zm-5.76-6.29c-1.55-2-3.07-4-3.93-5.14a9.88,9.88,0,0,1,.24-1.3,7.13,7.13,0,0,1,.6-1.6l0,0a2.7,2.7,0,0,1,.66-.79l0,0a1.74,1.74,0,0,1,1.08-.37c1.89,0,2,2.56,2.07,3.88A9.77,9.77,0,0,1,439.58,363.88Zm4.39-4.56c-.94,2.56-.45,4.31.27,4.48,1.44.33,2.63-1.65,3.24-3.3.48-1.29.74-3.84-.19-4.29C446.52,355.84,444.85,357,444,359.32ZM479.38,309c-.12.51-.23,1-.35,1.53A2.16,2.16,0,0,1,479.38,309Zm-4.7-4.56c-1.54,0-2.77,1.59-3.46,2.78A9.73,9.73,0,0,0,470,310.3a2.69,2.69,0,0,0,.07,1.77c.72,1.43,2.08,0,2.8-.65a9.89,9.89,0,0,0,3-4.51C476.16,305.82,476.12,304.44,474.68,304.41Zm7.68-8.71c-.3,1.37-.63,2.8-.95,4.27a1,1,0,0,1-1.11-.47c-.39-.73.27-1.7.65-2.27A9.15,9.15,0,0,1,482.36,295.7Zm-11.24,20.95c-1.11,2.49-.73,4.27,0,4.48,1.41.42,2.73-1.47,3.44-3.08.56-1.25,1-3.78.09-4.29C473.89,313.34,472.15,314.35,471.12,316.65Zm-9.05,9.48c-.93-.06-1.61.71-2,1.65a7.22,7.22,0,0,0-.69,2.17c-.06.48,0,1.16.63,1.21s1.33-.78,1.64-1.26S463.93,326.25,462.07,326.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.09,433.46c-1.95-.65-.21-6.3,2-8a56.33,56.33,0,0,1,6.48-3.41c7.09-3.41,17.27-8,17.27-8l-8.68-36.78,35.37.2s9.66,34.53,9.6,36.68c0,.13,0,.26,0,.4-.3,9.74-.78,17.72-1.58,18.22C442.35,434.13,386.06,434.12,384.09,433.46Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.09,433.46c2,.66,58.27.67,60.41-.69.8-.5,1.28-8.47,1.59-18.22v-.4A42.43,42.43,0,0,0,445,409H408.61l1.19,5.07s-10.19,4.55-17.27,7.95a55.79,55.79,0,0,0-6.48,3.42C383.87,427.16,382.14,432.81,384.09,433.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.46,433.78c2,.67,59.32.6,61.5-.79.84-.51,1.31-8.86,1.6-19,0-.11,0-.21,0-.32l-37-.37V414s-21.92,9.84-24.16,11.62S381.46,433.11,383.46,433.78Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.11,431.55c9.66-.25,48.65-.34,58.22.15.08,0,.08.06,0,.06-9.57.46-48.56.23-58.22-.05C383.9,431.71,383.9,431.56,384.11,431.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.47,413.44c3.8-.71,8.45-.13,11.36,2.57.12.11,0,.26-.16.23a53.16,53.16,0,0,0-11.18-2.32A.24.24,0,0,1,405.47,413.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.73,415.1c3.8-.72,8.45-.14,11.36,2.57.11.1,0,.26-.16.22a53.91,53.91,0,0,0-11.18-2.31A.24.24,0,0,1,402.73,415.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400,416.76c3.8-.72,8.45-.14,11.36,2.57.11.1,0,.26-.16.22A53.36,53.36,0,0,0,400,417.24.24.24,0,0,1,400,416.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.23,410.57c2.69,2.09,6.19,2.94,9.33,4.09a.47.47,0,0,0,.6-.47.11.11,0,0,0,.09-.14,20.37,20.37,0,0,0-5.87-8.7c-1.59-1.33-4.37-2.26-5.86-.2S400.66,409.35,402.23,410.57Zm-1-3.06c-.68-4.17,3.8-2,4.94-1a21.9,21.9,0,0,1,2,2.18,60.16,60.16,0,0,1,3.54,5c-1.51-.66-3.06-1.19-4.59-1.8C405.34,411.21,401.63,409.81,401.26,407.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.93,408.24c-.92-2.37-3.84-2.18-5.72-1.29a20.25,20.25,0,0,0-7.87,6.93.1.1,0,0,0,.05.16.47.47,0,0,0,.45.61c3.34-.33,6.94-.26,10.07-1.6C423.74,412.27,425.81,410.49,424.93,408.24Zm-8.14,4.88c-1.63.2-3.27.32-4.89.58a61.2,61.2,0,0,1,4.69-3.95,21.1,21.1,0,0,1,2.5-1.59c1.35-.71,6.24-1.69,4.53,2.17C422.68,412.47,418.74,412.88,416.79,413.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.78,352.77s6.34,23-4.72,29.74c-7.39,4.54-40.05-1.74-41.44-5.77C437,369.11,437,366.32,437,366.32l8.38,40.43-41.14.48s-7.72-33.45-5.74-69c.74-13.12,18.38-17.1,30.66-10.57,11.9,6.33,33.21,23.91,33.21,23.91Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.9,383.06c-2.21-5.43-2-7.56-7.58-24.4-.74-2.25-1.36-4.54-2-6.82s-1.5-4.71-2-7.11c0-.12-.21-.07-.18,0,.64,2.08,1.06,4.23,1.61,6.33s1.08,4.13,1.66,6.18c.25.89.51,1.77.76,2.65-.11-.18-.22-.36-.32-.54-.49-.83-1-1.66-1.48-2.48-1-1.68-2.29-3.27-3.2-5-.05-.11-.23,0-.16.09,1,1.68,1.79,3.55,2.77,5.28.47.83,1,1.65,1.48,2.47a15.78,15.78,0,0,0,1.48,2.18c.75,2.6,2.38,8.86,3.18,11.45,2.55,8.14,1.71,5.49,3.61,9.86C441.59,383.45,442,383.29,441.9,383.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.16,400.07c6.2-.07,12.38-.42,18.57-.54.12,0,.14-.18,0-.18-6.18,0-12.34-.28-18.51-.2s-12.38.37-18.57.58c-.16,0-.18.25,0,.25C410.82,400,417,400.13,423.16,400.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.34,398c-.56-2.74-1.35-5.42-2.08-8.12s-1.44-5.4-2.19-8.09c-1.49-5.39-3.05-10.76-4.6-16.13-.88-3.05-1.83-6.08-2.76-9.12a.07.07,0,0,0-.14,0q4.14,16.25,8.9,32.33c.89,3,1.71,6.13,2.78,9.11C438.27,398.08,438.36,398.06,438.34,398Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.06,382.51c11.07-6.79,4.73-29.75,4.73-29.75l-19.75-1-26.87,23.62.45,1.32C441,380.77,473.67,387.05,481.06,382.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404,406.3l.2.93,41.14-.48-6.45-31.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.05,437.7c.36,2-5.42,3.23-8,2.16a57.32,57.32,0,0,1-6.11-4c-6.4-4.57-15.29-11.31-15.29-11.31l-30.23,1.83-16.87-31.09s27.8-1.61,29.71-2.59l.35-.18c8.69-4.43,15.91-7.85,16.74-7.39C542.57,386.32,569.67,435.66,570.05,437.7Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518,393.47l15.91,31.47,6.79-.42s8.9,6.73,15.3,11.31a56.53,56.53,0,0,0,6.1,4c2.58,1.07,8.36-.13,8-2.16s-27.48-51.38-29.7-52.6c-.82-.46-8.05,3-16.74,7.39-.12.05-.23.12-.35.18A27.91,27.91,0,0,1,518,393.47Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.63,438.11c-.38-2.08-28-52.28-30.31-53.52-.85-.49-8.4,3.12-17.4,7.73l-.28.15,17.49,32.59.54-.32s19.18,14.48,21.82,15.58S571,440.18,570.63,438.11Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.37,438.61c-4.87-8.35-23.73-42.48-27.91-51.1,0-.07,0-.09,0,0,5,8.17,23.59,42.45,28,51C568.6,438.72,568.47,438.79,568.37,438.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.2,428.61c-2.45-3-4.19-7.34-3.22-11.19,0-.15.25-.1.28,0a53,53,0,0,0,3.36,10.91A.25.25,0,0,1,542.2,428.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545,430.22c-2.46-3-4.19-7.35-3.22-11.2,0-.15.25-.09.27,0A53.66,53.66,0,0,0,545.39,430,.24.24,0,0,1,545,430.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.75,431.82c-2.46-3-4.19-7.34-3.22-11.19,0-.15.25-.1.28,0a53.64,53.64,0,0,0,3.35,10.92A.24.24,0,0,1,547.75,431.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.25,432.84c.53-3.37-.41-6.85-.91-10.16a.47.47,0,0,0-.7-.29.1.1,0,0,0-.16,0,20.32,20.32,0,0,0-4.81,9.33c-.4,2,.13,4.92,2.66,5.23C539.71,437.24,540.94,434.8,541.25,432.84ZM539,435.16c-3.33,2.6-3.58-2.38-3.22-3.87a23.11,23.11,0,0,1,.93-2.81,58.43,58.43,0,0,1,2.69-5.51c.14,1.64.42,3.25.63,4.89C540.31,429.8,540.87,433.73,539,435.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.28,414.06c-1.64,1.95-.06,4.42,1.62,5.64a20.35,20.35,0,0,0,9.87,3.56.11.11,0,0,0,.11-.12.48.48,0,0,0,.32-.7c-1.9-2.76-3.58-5.95-6.26-8.05C532.38,413.17,529.82,412.21,528.28,414.06Zm8.19,4.78c1,1.34,1.86,2.71,2.87,4a60.8,60.8,0,0,1-5.72-2.2,23.45,23.45,0,0,1-2.6-1.43c-1.28-.85-4.49-4.66-.28-5C533.06,414,535.32,417.25,536.47,418.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.76,347.15a168.17,168.17,0,0,0-1,16.85S419.72,384.48,417.94,404c-.63,6.89.29,19.81,13.81,25.7,15.11,6.58,98.6,2.05,98.6,2.05l-10.43-38.44H483.09s26,4.14,28.81-13.18c2.62-16.09-7.26-32.94-7.26-32.94Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.72,429.82c-.92-4.43-1.81-8.88-2.83-13.29s-2.13-8.81-3.29-13.19c-.33-1.24-.67-2.47-1-3.7-.16-.59-.32-1.18-.49-1.76s-.31-1.21-.54-1.77c0-.06-.1,0-.09,0a28.34,28.34,0,0,0,.66,3.4l.69,3.21q.72,3.3,1.48,6.58c1,4.4,2.12,8.75,3.27,13.11.64,2.47,1.3,4.94,1.95,7.41C521.57,430,521.75,430,521.72,429.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.81,393.27c-3-.22-6-.31-9-.37s-6,0-9,0-6,.22-9,.48a66.2,66.2,0,0,0-8.88,1.29l2.22-.29,2.23-.21c1.48-.13,3-.25,4.46-.32,3-.17,6-.29,8.95-.34s6-.13,8.95-.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.46,350.3a107.65,107.65,0,0,1,3.47,10.46,67.49,67.49,0,0,1,2.13,10.77,30.21,30.21,0,0,1,.11,5.46,13.54,13.54,0,0,1-1.32,5.19,7.41,7.41,0,0,1-1.6,2.08,13.05,13.05,0,0,1-2.19,1.54,24.63,24.63,0,0,1-5,2,68.4,68.4,0,0,1-10.78,1.95c-3.64.43-7.3.72-11,1.1a78.58,78.58,0,0,0-11,1.7,21.5,21.5,0,0,0-5.26,1.94,25.29,25.29,0,0,0-4.58,3.24l-.83.74,1.12,0,29.78-.4,14.89-.12c5,0,9.92,0,14.88.11-4.95-.29-9.92-.37-14.88-.46s-9.93-.09-14.9-.11H464.67l-14.89.14.29.72a24.38,24.38,0,0,1,4.42-3.1,20.54,20.54,0,0,1,5.06-1.84,88.87,88.87,0,0,1,10.84-1.67c3.65-.39,7.31-.7,11-1.15a68.81,68.81,0,0,0,10.9-2,23.51,23.51,0,0,0,5.17-2.14,13.62,13.62,0,0,0,2.29-1.66,8.12,8.12,0,0,0,1.71-2.29,14.26,14.26,0,0,0,1.32-5.45,31.17,31.17,0,0,0-.19-5.55,64,64,0,0,0-2.36-10.8A95.07,95.07,0,0,0,496.46,350.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464,346.74a.07.07,0,0,0-.14,0c-.16,1.33-.62,8.93-.85,11.8-.09,1,0,2.84-1.52,2.84-1.18,0-1.76-1.29-1.89-2.29-.16-1.21.49-10,.64-13,0-.08-.13-.09-.15,0-.54,2.95-1.59,12.31-1.27,13.62a3,3,0,0,0,1.82,2.35,18.88,18.88,0,0,0,.05,3.47c0,.1.3.13.33,0h0c0-.69.32-3.35.31-3.37a2.1,2.1,0,0,0,1.89-.86C464.27,360,464,350.13,464,346.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.23,369.3c-1.06-.74-2.16-1.41-3.27-2.06s-2.24-1.28-3.38-1.89-2.28-1.18-3.46-1.72-2.35-1.06-3.57-1.49c.55.34,1.12.64,1.67,1l1.69.94c1.12.63,2.26,1.23,3.39,1.84s2.28,1.19,3.44,1.76l1.73.84C467.06,368.76,467.64,369,468.23,369.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496,363.18c-2.07,0-8.54.37-11.62-2.23-2.49-2.11-3.59-9.29-4-11.27,0-.1-.16-.06-.16,0a22.69,22.69,0,0,0,.83,6.6c.5,1.82,1.18,3.85,2.65,5.13a10.45,10.45,0,0,0,5.63,2.06,25.91,25.91,0,0,0,6.7-.1A.11.11,0,0,0,496,363.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.73,282a4.21,4.21,0,0,0,6.37-4.22,3.88,3.88,0,0,0,4.7-.63,3.72,3.72,0,0,0,0-4.93s0,0,0,0a3.81,3.81,0,0,1-.23,4.69,3.43,3.43,0,0,1-3.71.8,4.7,4.7,0,0,0,3.4-1.52,3.62,3.62,0,0,0,.49-4,5.3,5.3,0,0,0,3-3.68,3.59,3.59,0,0,0-1.54-3.64,4,4,0,0,0-1.7-7.22,3.39,3.39,0,0,0-1-5.62,2.28,2.28,0,0,0,.17-2.46,3.79,3.79,0,0,0-2.37-1.72,2.75,2.75,0,0,0-1-2.4,2.49,2.49,0,0,0-3.2.25,6.83,6.83,0,0,0-3.86-2.93,3.57,3.57,0,0,0-3.68,1.34,4.9,4.9,0,0,0-7.32.32,3.46,3.46,0,0,0-3.44.08,5,5,0,0,0-1.8,1.67,2.58,2.58,0,0,0-3,.6,3.4,3.4,0,0,0-.79,2.8,2,2,0,0,1-.55.68,4.48,4.48,0,0,0-1.72,3.87,3.05,3.05,0,0,0-1.55,4.31,3.43,3.43,0,0,0-.53,4.8,5,5,0,0,0-1.56,3.86,2.91,2.91,0,0,0,1.7,2.7,1.75,1.75,0,0,0,.32,2.31,4.05,4.05,0,0,0,.78.58,3.76,3.76,0,0,1,1,.68,2.57,2.57,0,0,1,.31,1.16,4.26,4.26,0,0,0,.28.78,4.55,4.55,0,0,0,5.17,2.39,3.69,3.69,0,0,0,3.17,2.45,7.89,7.89,0,0,0,1.37.09,1.92,1.92,0,0,1,1.17.27c.23.15.42.34.65.49a3.13,3.13,0,0,0,2.49.24C492.89,285.12,497.75,285.05,499.73,282ZM480,247.44a2.72,2.72,0,0,1,2.95-1.09l-.06.13s-.38,0-.56,0a3.51,3.51,0,0,0-.95.3,3.55,3.55,0,0,0-1.53,1.39,3.82,3.82,0,0,0-.36.86l0,.11A3.32,3.32,0,0,1,480,247.44Zm26.24-1a2.62,2.62,0,0,0-3-.47l0-.07a2.31,2.31,0,0,1,3-.19,2.28,2.28,0,0,1,.86,2.11h0A2.88,2.88,0,0,0,506.25,246.43ZM492,281.26h0a4.72,4.72,0,0,0,6.37,1.69C496.11,284.44,493.27,284.41,492,281.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.93,294.92c2.35.6,8.2-2.8,10.91-6.14.18-.23.28-3,.56-6.31.17-2,.42-4.26.79-6.3l-13.33.78a32.79,32.79,0,0,1-.19,8,4.65,4.65,0,0,1-.24.82,1.27,1.27,0,0,0,0,.14C479.84,287.47,478.25,294,481.93,294.92Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.69,286.25a8.56,8.56,0,0,1-1.3-.31c0-.06,0-.1,0-.14a3.41,3.41,0,0,0,.24-.82,32.87,32.87,0,0,0,.19-8l12.37-.72C492.1,279.42,488.6,287.34,481.69,286.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500,260.67c.25,4.81-5.33,17.11-9.22,19.19-5.64,3-13.27,1.53-15.43-4.88-2.09-6.22,5.46-22.12,9.65-23.85C491.2,248.59,499.65,253.58,500,260.67Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.84,264.79s.05.07,0,.11c-.43.8-.79,1.79-.19,2.43,0,0,0,.06,0,0C483.81,266.79,484.3,265.48,484.84,264.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486,264.31c1.35.55.14,3.23-1.12,2.71S484.86,263.84,486,264.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.5,262.65s-.08,0-.1.05c-.35.84-.89,1.74-1.76,1.68,0,0,0,0,0,.05C479.6,264.71,480.3,263.5,480.5,262.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.15,261.45c-1.28-.7-2.6,1.92-1.41,2.58S481.23,262,480.15,261.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.6,263.56a11.28,11.28,0,0,1-.87-.83,1.94,1.94,0,0,1-.72-1,.61.61,0,0,1,.4-.64,1.54,1.54,0,0,1,1.48.49,2.25,2.25,0,0,1,.78,1.43A.66.66,0,0,1,487.6,263.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.69,260a9.85,9.85,0,0,0,1.19.2,1.91,1.91,0,0,0,1.25,0,.6.6,0,0,0,.28-.7,1.52,1.52,0,0,0-1.27-.9,2.28,2.28,0,0,0-1.62.22A.66.66,0,0,0,479.69,260Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.61,273.08a1.43,1.43,0,0,1-.92.17,2.51,2.51,0,0,1-.8-.61s-.06,0-.05,0a1.22,1.22,0,0,0,.85.93,1,1,0,0,0,1-.44A0,0,0,0,0,482.61,273.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.86,270.2a3.1,3.1,0,0,1-2.45.41,4.05,4.05,0,0,1-1-.42l-.18-.11A.82.82,0,0,1,479,270a.22.22,0,0,1-.08-.26h0a.41.41,0,0,1,.05-.09h0l0-.07c.28-.65.78-1.59.78-1.59-.29,0-1.72,0-1.55-.32a46.65,46.65,0,0,1,5-8,.08.08,0,0,1,.14.09c-1.25,2.63-3,5-4.27,7.65a5.41,5.41,0,0,1,1.51.2c.08.07-1,1.8-1.1,2.1v0a4.29,4.29,0,0,0,3.33.41C482.9,270.07,482.94,270.16,482.86,270.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.9,270a3.68,3.68,0,0,0,.86,1.64,1.62,1.62,0,0,0,.89.48c.74.12,1-.48,1.15-1.05a4.17,4.17,0,0,0,.06-.93A4.79,4.79,0,0,1,479.9,270Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.76,271.68a1.62,1.62,0,0,0,.89.48c.74.12,1-.48,1.15-1.05A1.72,1.72,0,0,0,480.76,271.68Z",
    style: {
      fill: "#ff99ba"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.77,257.52c.49.14,2.64-.47,3.74-3.24.87.52,3.22-.3,4.12-.91a4.37,4.37,0,0,0,5.61,4.73,6.09,6.09,0,0,0,.14,3.83,5.57,5.57,0,0,0,2.25,2.59h0c-1.29,2.19.14,4.84,2.2,5a2.73,2.73,0,0,0,.57,0,3.42,3.42,0,0,0,2.83-1.25,3.49,3.49,0,0,0,0-4.18,3.27,3.27,0,0,0,1.44-3.32c-.15-.81-.94-1.43-.77-2.28a5,5,0,0,0,0-2.07,3.9,3.9,0,0,0-1.84-2.64,2.19,2.19,0,0,1-1-1,7.63,7.63,0,0,0-.48-.84,4.75,4.75,0,0,0-1.13-1.15,4.57,4.57,0,0,0-1.72-.79c-.67-.15-1.44,0-2-.39a9.17,9.17,0,0,0-2.94-.81,7,7,0,0,0-4.16.87,4.68,4.68,0,0,0-3.1,1.37,6,6,0,0,0-1.92,2.74s-.58.1-1.24,1.13A3.81,3.81,0,0,0,479.77,257.52Zm15.84,7.14a5.27,5.27,0,0,0,.43,3.54A3.29,3.29,0,0,1,495.61,264.66Zm-7.77-11.15a5.12,5.12,0,0,0,2.47,4A4.06,4.06,0,0,1,487.84,253.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.63,270.49s4-3.36,5.63-1.82-2.21,7-4.64,7.19a2.33,2.33,0,0,1-2.69-2Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.13,270.2a0,0,0,0,1,0,.06,5.89,5.89,0,0,0-3.9,2.76,1.29,1.29,0,0,1,1.95.16s0,.1-.06.07a1.46,1.46,0,0,0-1.66.07,7,7,0,0,0-1.06,1c-.11.12-.34,0-.24-.17l0,0C494.67,272.17,497,269.82,499.13,270.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.07,361.29c-.15.14-54.17-8.85-54.63-9.49-.18-.24-4.13-3.17-2.22-9.48.53-1.74,2.93-3.71,3.77-6.09,5-14.39,14.49-42.2,21.14-49.41,2.63-2.86,10.68-3.77,14-.49C507.24,300.4,511.59,360.8,511.07,361.29Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.67,285s-12,53.08-12.44,59.68,3.9,21.72,3.9,21.72c8.26,9.67,44.51,16.95,44.51,16.95s-10.12-88.81-22.45-97C487.71,282.06,480.67,285,480.67,285Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.92,345.86a3.27,3.27,0,0,0-1.73,2.57,10.31,10.31,0,0,0-.44,4.61c.12.85.49,2.09,1.59,1.88s1.69-2.08,2-3S511.46,344.79,508.92,345.86ZM500.28,353c-1.19,1-1.06,3-.81,4.37a9.92,9.92,0,0,0,1.09,3.16,2.71,2.71,0,0,0,1.21,1.3c1.48.61,1.59-1.34,1.7-2.32a9.84,9.84,0,0,0-.66-5.39C502.32,353.11,501.39,352.09,500.28,353Zm4.52-13.93c-.91-.11-1.42.59-1.68,1.51a8.42,8.42,0,0,0-.37,3.32c.08.67.22,1.84,1,2.14s1.36-.5,1.63-1.1C505.85,343.82,506.82,339.33,504.8,339.07Zm7.91,32.49c-.74-.53-1.52-.17-2.2.51a8.55,8.55,0,0,0-1.91,2.74c-.26.63-.69,1.72-.17,2.34s1.43.23,1.95-.17C511.35,376.23,514.36,372.76,512.71,371.56Zm-39.26-39.28c-1,1.22-.42,3.17.1,4.45a9.55,9.55,0,0,0,1.71,2.87,2.75,2.75,0,0,0,1.45,1c1.58.3,1.29-1.64,1.19-2.62a9.92,9.92,0,0,0-1.74-5.14C475.47,332,474.34,331.16,473.45,332.28Zm-.76,12.53c-.85.33-1,1.19-.77,2.13a8.66,8.66,0,0,0,1.23,3.1c.39.55,1.06,1.52,1.87,1.43s1-1.08.92-1.74C475.85,348.52,474.6,344.1,472.69,344.81Zm21.72-5.61c.88-.05,1.71,1.21,2.1,1.86a9.47,9.47,0,0,1,1.16,3.54c.09.72.35,2.23-.32,2.78-.82.66-1.6-.1-2.17-1.13a8.08,8.08,0,0,1-1.72-5.17C493.46,340.44,493.54,339.26,494.41,339.2Zm3.78,25.08c-1.17.87-.67,2.57-.21,3.68a10,10,0,0,0,3.56,4.38c.67.46,1.66,1,2.37.74s1-.84.95-1.77a9.3,9.3,0,0,0-2.68-5.17C501.3,365.15,499.71,363.15,498.19,364.28Zm7.38.32c.78,2.61,2.23,3.71,2.91,3.41,1.34-.6,1.1-2.89.6-4.58-.4-1.32-1.72-3.52-2.73-3.31C505.51,360.29,504.85,362.18,505.57,364.6Zm-27-13c-.44,2.69.38,4.31,1.13,4.34,1.47,0,2.25-2.12,2.54-3.86.22-1.36,0-3.92-1-4.17C480.41,347.68,479,349.1,478.58,351.59Zm16.8-52.31a3.27,3.27,0,0,0-2.88,1.14,10.39,10.39,0,0,0-3,3.56c-.38.76-.77,2,.25,2.44s2.57-.75,3.34-1.37S498.08,299.84,495.38,299.28Zm-11.16,1c-1.54.14-2.59,1.88-3.15,3.14a9.8,9.8,0,0,0-.89,3.22,2.75,2.75,0,0,0,.26,1.76c.87,1.34,2.08-.21,2.72-.95a9.94,9.94,0,0,0,2.51-4.81C485.83,301.53,485.64,300.15,484.22,300.28Zm9.87-10.63c-.69-.61-1.51-.32-2.24.29a8.48,8.48,0,0,0-2.18,2.53c-.32.6-.86,1.64-.41,2.32s1.4.36,2,0C492.26,294.16,495.6,291,494.09,289.65ZM482,312.83c-.83,2.6-.26,4.32.47,4.46,1.44.27,2.55-1.76,3.09-3.43.42-1.31.57-3.88-.38-4.28C484.4,309.24,482.78,310.43,482,312.83Zm18.05,14.37a2.26,2.26,0,0,0-.63,2.54,7.05,7.05,0,0,0,.76,2.14c.24.43.7.93,1.23.59s.59-1.42.55-2C501.92,329.74,501.6,326.17,500.05,327.2Zm-3.7-17.92a2.28,2.28,0,0,0-2.61.21,7.33,7.33,0,0,0-1.79,1.4c-.33.37-.66,1-.17,1.35s1.54.11,2.07-.1S497.81,310.42,496.35,309.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.42,298.08c-7.49,3.21-40.71,13.45-49.44,7.15-10.58-7.64-20.31-21.68-24.78-26.71-1.12-1.26,19.48-15,21.84-11.7,3.67,5.14,10.78,16.38,11.85,17.2,1.87,1.43,24,3.21,35.33,4.22C496.44,289.15,495.83,296.18,491.42,298.08Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.8,272.37s-2-3.85-2.15-4.1a15.22,15.22,0,0,1-1.37-4.25c-1.26-5.65-8-18.6-24-21.07-6.16-.95-9.51,3-3.29,5.08,4.39,1.49,7.55,2.15,8.85,3,0,0-6.68,2.39-7.79,6.35A77.1,77.1,0,0,0,410.85,268a16.34,16.34,0,0,0,1.94.58,8.63,8.63,0,0,0,3.38,8.56l4.29,5.38Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.21,258.82c-2.44-1.79-7.69-5.51-13-7-5.95-1.72-17.86-3.42-19.08,1-.9,3.22,3.59,4.27,3.59,4.27s-5.07.34-5.24,3.43c-.16,2.82,3.36,3.42,3.36,3.42s-3,.73-2.67,3.48c.45,3.29,6.75,1.22,10.1,4.17C415,272.18,437.21,258.82,437.21,258.82Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.4,258.35a24.7,24.7,0,0,0-14.63-1.42c-.12,0-.16.14,0,.14a60.58,60.58,0,0,1,14.65,1.33A0,0,0,1,0,423.4,258.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.49,264.3c-2.34-.9-9.23-2.12-14.68-.54-.12,0-.16.15,0,.14a64.43,64.43,0,0,1,14.71.46A0,0,0,0,0,421.49,264.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.17,308.28l-1.58-24.36s27,1.72,38.92,4.47c10,2.31,9.38,8.25-3.14,12.15C475.51,304.23,453.17,308.28,453.17,308.28Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.38,293.62c-1.44-.55-3.15.55-4.21,1.43a10,10,0,0,0-2.22,2.5,2.78,2.78,0,0,0-.54,1.69c.19,1.59,1.95.73,2.86.35a9.93,9.93,0,0,0,4.37-3.21C462.28,295.45,462.72,294.14,461.38,293.62Zm5.93-6.59c-.35-.84-1.21-.95-2.14-.73a8.65,8.65,0,0,0-3.07,1.31c-.55.4-1.5,1.09-1.39,1.9s1.1.95,1.76.88C463.68,290.28,468.07,288.92,467.31,287Zm18.26,14.05c-1.19.34-2.47.7-3.79,1a3.47,3.47,0,0,1,2.44-1.84A1.19,1.19,0,0,1,485.57,301.08Zm8.52-11.43c-.69-.61-1.51-.32-2.24.29a8.48,8.48,0,0,0-2.18,2.53c-.32.6-.86,1.64-.41,2.32s1.4.36,2,0C492.26,294.16,495.6,291,494.09,289.65Zm-26.19,2c-2.67.5-3.92,1.83-3.69,2.53.46,1.4,2.76,1.4,4.49,1.07,1.36-.25,3.68-1.34,3.58-2.37C472.2,292,470.38,291.18,467.9,291.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.84,286.9a40.79,40.79,0,0,1,.6,4.65c.17,1.61.28,3.22.4,4.82s.35,8,.41,9.62c0,.07-.13.07-.14,0-.17-1.6-.87-8-1-9.55s-.23-3.15-.29-4.72a40.68,40.68,0,0,1-.08-4.81S456.83,286.86,456.84,286.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.35,299.07a184.88,184.88,0,0,1-38.29,9.34c0-.86-.05-1.72-.05-2.58.1.81.19,1.62.27,2.44l-.13-.11c3.22-.62,6.43-1.22,9.63-1.94,9.25-2,19.39-4.66,28.57-7.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.83,300a8.67,8.67,0,0,1-4.31.46c1.45-.1,2.86-.3,4.31-.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.65,286.43a49.52,49.52,0,0,1,11.48,1.88,101.7,101.7,0,0,1-11.48-1.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.92,287.44a6,6,0,0,1,3-.18,17.36,17.36,0,0,1-3,.18Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-179"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M392.07,433.24c-2,.69-60.36.82-62.58-.59-.86-.52-1.37-9-1.7-19.3V413c-.07-2.12-3-37-3-37l38,.46,2.6,36.08v.64s22.34,9.93,24.63,11.74S394.1,432.56,392.07,433.24Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.06,433.24c-2,.7-60.35.82-62.57-.59-.73-.44-1.22-6.71-1.54-14.93,9.16,1.52,53.32,8.66,54.34,5,.21-.78-.8-1.82-2.14-2.81a98.4,98.4,0,0,1,9.88,5C392.29,426.71,394.1,432.56,392.06,433.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.28,240.69S314.93,317,316,322.26c1.67,8.16,9.88,89.85,9.88,89.85l41.76-.06s-8.1-72.19-15.19-95.64c-5.11-16.89-43.16-73.31-43.16-73.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.83,404.86c-6.32-.17-28.73-.86-37.16-.2-.07,0-.07.12,0,.13,2.89.49,30.84.35,37.17.26A.1.1,0,0,0,364.83,404.86Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.54,445.33c-2.15.07-58-16.87-59.66-18.87-.67-.75,1.33-9,4-18.95l.09-.31c.55-2.05,14.45-32.9,14.45-32.9l36.19,11.55-14.51,31.87-.2.61s18.46,16,20.11,18.43S303.69,445.27,301.54,445.33Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.54,445.33c-2.15.07-58-16.87-59.66-18.87-.57-.64.8-6.77,2.89-14.73,8.32,4.14,48.46,23.88,50.51,20.66.43-.69-.23-2-1.23-3.31a93.83,93.83,0,0,1,8,7.68C303.67,439.14,303.69,445.27,301.54,445.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.42,419l-41.2-11.63s43-85.52,42.83-90.91c-.19-4.78-28.17-47.17-29.62-55-2.36-12.88,4.1-24.22,10.29-31.2l42.59,12.86s-3.55,7.34-9.9,11.9c0,0,26.08,45.43,26.5,60.23S284.42,419,284.42,419Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.22,411.57c-6-1.83-4.23-1.39-10.22-3.15-2.94-.87-22.22-6.52-25.09-6.85-.07,0-.1.1,0,.13,2.62,1.23,22,6.55,24.95,7.36,6,1.64,4.31,1.1,10.35,2.69C285.29,411.77,285.34,411.6,285.22,411.57Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306,253.4a77.32,77.32,0,0,0-12,5.37.13.13,0,0,0,.11.24c4-1.67,8.14-3.27,12.07-5.15C306.55,253.72,306.34,253.29,306,253.4Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301,252.25a17,17,0,0,0-.81,2.3,4.88,4.88,0,0,0-.33,1.88c0,.12.18.14.25.05a6.32,6.32,0,0,0,.83-1.83c.27-.71.56-1.42.81-2.13A.4.4,0,0,0,301,252.25Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.09,248.37c.18-.65.36-1.31.56-2s.45-1.34.59-2a.09.09,0,0,1,.17.05c-.18.66-.27,1.34-.4,2s-.27,1.34-.41,2c-.27,1.24-.63,2.49-1,3.7a4.54,4.54,0,0,0,1.92-.55,3.58,3.58,0,0,0,1.2-1.81c.28-.74.53-1.49.83-2.23a15.52,15.52,0,0,0,.87-2.48c0-.11.19-.06.16,0a27.11,27.11,0,0,1-1.62,5.26,2.94,2.94,0,0,1-1.2,1.66,5.84,5.84,0,0,1-2.31.41c-.09,0-.22,0-.2-.13C300.46,251,300.73,249.66,301.09,248.37Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.22,256.49c1.57,3,3.39,5.82,5.07,8.73s3.22,5.73,4.75,8.63q4.65,8.81,8.55,18c1.28,3,2.5,6.08,3.63,9.16a69.63,69.63,0,0,1,2.93,9.44,25.5,25.5,0,0,1,.24,9.77,66.76,66.76,0,0,1-2.7,9.7,177.16,177.16,0,0,1-8.48,21.32c-.11.23-.5,0-.41-.19,2.38-6.34,4.84-12.65,7-19.07,2.09-6.23,4.55-12.69,3.58-19.36a50.13,50.13,0,0,0-2.54-9.39q-1.65-4.7-3.55-9.28c-2.49-6-5.3-11.9-8.18-17.75-1.61-3.28-3.3-6.52-4.93-9.79s-3.24-6.66-5.1-9.84C300,256.47,300.17,256.39,300.22,256.49Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.15,249.63c.78-.12,1.91.17,5.27,0a17.45,17.45,0,0,0,2.77-.4,6,6,0,0,0,2.57-1,13.43,13.43,0,0,0,3-4,20.71,20.71,0,0,0,2.13-4.93c0-.1.18,0,.16.05-.2,1-.31,2-.59,2.93a17.61,17.61,0,0,1-1,2.64,10.76,10.76,0,0,1-3.08,4.37c-1.53,1.12-3.65,1.29-5.49,1.38-1.06.06-5.22-.13-5.77-.74C269,249.88,269,249.65,269.15,249.63Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.76,400.46c4.71-11.67,30-63.25,34.94-74a42.88,42.88,0,0,0,3.24-8c.7-3-.19-5.78-1.42-8.53a145.3,145.3,0,0,0-7.73-14.66c-2.82-4.76-5.81-9.43-8.76-14.12a144.58,144.58,0,0,1-8.38-14.26,25.83,25.83,0,0,1-2.72-15c.77-5.21,3.12-10.08,5.64-14.65.66-1.21,1.34-2.41,2-3.62.05-.09.19,0,.14.09-2.8,4.79-5.49,9.83-6.85,15.25a24.89,24.89,0,0,0-.75,8.2,26,26,0,0,0,2.17,8.06c2.16,5,5.22,9.6,8.09,14.19s5.95,9.36,8.81,14.1a157.93,157.93,0,0,1,8,14.7,21.44,21.44,0,0,1,2.43,7.1c.24,2.75-.8,5.36-1.9,7.82-4.8,10.71-36,76.2-36.69,77.52C251.91,400.78,251.69,400.63,251.76,400.46Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.22,160.65s8.12-4.42,15.33,0S343.19,176,342,185.11s6.33,15.18,7.15,22-3.71,9.93-5.23,13.5c-1.74,4.08,5.23,18.57-12.5,21.93-22.16,4.21-30.64-9.23-28.38-20.34,1.11-5.44,4.21-9.3,4.16-13.71s-3.22-7.91-1.57-13.49,3.83-4.82,4.73-13.59S309.37,162.14,317.22,160.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331,160.44a27.19,27.19,0,0,1,10.48,12.43,24.74,24.74,0,0,1,1.88,7.95c.23,3.57-.33,6.92,1,10.38,2.16,5.56,6.48,10.19,6.28,16.37a15.18,15.18,0,0,1-2.67,8.07c-1.91,2.8-4.64,5-6.24,8a.11.11,0,0,1-.2-.11c1.33-2.66,3.5-4.69,5.3-7.07a15.37,15.37,0,0,0,3.28-9.72c-.17-5.88-4.43-10.39-6.42-15.75a18.56,18.56,0,0,1-.88-7.32,26.27,26.27,0,0,0-1.15-8.84A28.59,28.59,0,0,0,331,160.52S331,160.41,331,160.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.34,227.21a0,0,0,1,1,0,0A0,0,0,1,1,340.34,227.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.07,220.6c.56-2.63,1.95-5,2.51-7.63.67-3.15-.14-6.29-.75-9.39-.87-4.42-.77-8.59,1.21-12.75a75.27,75.27,0,0,0,3.78-8,32.45,32.45,0,0,0,1.69-9.49c0-.07.12-.07.12,0a29.94,29.94,0,0,1-3,13.54c-1.21,2.48-2.72,4.81-3.41,7.5a21.87,21.87,0,0,0,.06,9.56,36,36,0,0,1,.82,6.53,17.9,17.9,0,0,1-1.56,6.43,22.35,22.35,0,0,0,.09,16.67c0,.1-.13.16-.17.07A21.26,21.26,0,0,1,303.07,220.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.69,206.29c-.2-4.84-3.62-8.13-5.7-12.32-1.57-3.17-2.63-6.56-2.11-10.05a.06.06,0,0,1,.11,0c-.27,5.06,1.88,9.64,4.72,13.88,1.89,2.81,3.46,5.52,3.47,8.91s-1.33,6.12-3.25,8.86a18.94,18.94,0,0,0-3.29,6.1,24.57,24.57,0,0,0-.33,7.06c0,.12-.2.12-.21,0-.32-3.63-.38-7.14,1.48-10.45C346.85,214.22,349.89,211.21,349.69,206.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.22,217.16a29.82,29.82,0,0,1,2.82-4.68,9.53,9.53,0,0,0,1.57-8.17c0-.07.1-.1.12,0,.9,2.66,1.12,4.87-.48,7.33-2.24,3.42-4.43,6.54-4.89,10.62-.81,7.25,3.34,14,10.08,17.68a.08.08,0,0,1-.09.14c-5.65-2.74-9.62-7.71-10.44-13.56A17.13,17.13,0,0,1,302.22,217.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.74,189.5c-.22.9.94,8,4.69,9.73,1.22.55,4.51-6,4.51-6l.36-.42,4.94-6-5.32-9.11-.8-1.25s-1.25,1.72-2.78,3.88l-.21.3-.26.35-.7,1c-.17.25-.34.49-.51.76s-.36.53-.54.8A50.77,50.77,0,0,0,308.74,189.5Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.34,180.38a15.52,15.52,0,0,0,4,12.45l4.94-6-5.32-9.11-.8-1.25S315.87,178.22,314.34,180.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.91,177.25c-.87,13.57-9.07,14.72-12,14.39-2.64-.3-11.68-1.1-12.21-14.69s6-17.47,12.14-17.39S338.78,163.68,337.91,177.25Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.19,174a8.52,8.52,0,0,1-.9-.26,1.56,1.56,0,0,1-.87-.45.48.48,0,0,1,.05-.59,1.2,1.2,0,0,1,1.2-.19,1.77,1.77,0,0,1,1.05.71A.52.52,0,0,1,337.19,174Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.4,173.77c.32,0,.61-.08.93-.12a1.52,1.52,0,0,0,.93-.3.48.48,0,0,0,0-.59,1.19,1.19,0,0,0-1.15-.38,1.78,1.78,0,0,0-1.16.54A.52.52,0,0,0,328.4,173.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.13,177.26s-.08,0-.08.08c0,.93-.2,2-1.06,2.24,0,0,0,.06,0,.06C330,179.55,330.25,178.14,330.13,177.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.36,176.25c-1.48-.2-1.77,2.78-.4,3S330.6,176.42,329.36,176.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.76,176.35c-.28.15-.56.42-.88.42s-.61-.34-.82-.66c0,0-.05,0-.05,0-.06.57.1,1.17.7,1.32s1-.34,1.2-.9C329,176.46,328.87,176.3,328.76,176.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.13,177.23s.07.05.06.09c-.12.91-.11,2,.69,2.38,0,0,0,.06,0,.05C334.86,179.5,334.86,178.08,335.13,177.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.05,176.35c1.49,0,1.3,3-.08,3S334.8,176.32,336.05,176.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.66,176.59c.23.17.44.47.72.51s.59-.27.82-.56c0,0,0,0,0,0,0,.57-.25,1.16-.8,1.23s-.84-.44-.94-1C336.48,176.67,336.57,176.52,336.66,176.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.43,184.38c.19.24.36.57.69.64a2.21,2.21,0,0,0,1-.09s.06,0,0,.06a1.26,1.26,0,0,1-1.23.33,1,1,0,0,1-.61-.91A.05.05,0,0,1,329.43,184.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.57,181.37s.07,1.39,0,2c0,.06-.17.08-.39.07,0,0,0,0,0,0a3.1,3.1,0,0,1-2.9-1.41c0-.06.05-.12.1-.08a4.76,4.76,0,0,0,2.76,1c.06-.18-.21-2.39-.11-2.38a6,6,0,0,1,1.45.45c-.07-2.9-.6-5.78-.63-8.67a.09.09,0,0,1,.17,0,46.75,46.75,0,0,1,1.08,9.32C335.11,182.1,333.82,181.5,333.57,181.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.19,183a3.87,3.87,0,0,1-1.48,1.22,1.74,1.74,0,0,1-1,.1c-.75-.18-.79-.86-.67-1.46a4.06,4.06,0,0,1,.3-.91A5,5,0,0,0,333.19,183Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.71,184.2a1.74,1.74,0,0,1-1,.1c-.75-.18-.79-.86-.67-1.46A1.78,1.78,0,0,1,331.71,184.2Z",
    style: {
      fill: "#ff99ba"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314,177.12c1.49.08,5.81-3.55,6.73-10.67,0,0-1.27,6.34-1.86,7.22s2.41-2,3.24-7.78a23.44,23.44,0,0,0,5.56,3.74c2.64,1.07,4.3,1.23,4.52,1.06s-3.64-1.89-4.58-3.26c0,0,6.85,4.18,10.15,4.81.39.08.83-6.26-3.94-10.21s-12.44-2.79-14.87-.92c0,0-2.62.08-5.86,3.57S312.44,177,314,177.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.35,177.46s-2.89-4.3-4.83-3.27.18,7.21,2.43,8.09a2.3,2.3,0,0,0,3.1-1.18Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.17,176s0,0,0,.06a5.83,5.83,0,0,1,2.94,3.68,1.28,1.28,0,0,0-1.89-.38s0,.1,0,.09a1.41,1.41,0,0,1,1.55.52,7.18,7.18,0,0,1,.72,1.27c.07.14.33.07.28-.09l0,0C315.86,179,314.34,176.19,312.17,176Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.07,234.41l-3.38,10.74-45.32-15.51s20.05-32.36,36.73-39.32c8.34-3.48,14.66,0,16.88,6.11.57,1.56,5.34,22,3.74,29C321.3,231.52,314.07,234.41,314.07,234.41Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.65,199.84c-2.94,7.44-11.14,37.61-4.71,46,7.78,10.18,21.83,19.35,26.89,23.6,1.27,1.07,14.2-19.53,10.89-21.75-5.14-3.46-17-11.37-17.8-12.4-1.46-1.79-3.2-22.22-4.5-33.33C317.25,192,309.39,195.45,307.65,199.84Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.35,259.08c-.77-1.27-.11-1.69,2.36-.76s11.48,6.72,13.23,3.41-11.07-11.29-15.31-12.52a69.53,69.53,0,0,0-11.52-1.75C340.29,249.51,345.11,255,349.35,259.08Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.85,265.1c6.36,5.56,13.94,12.86,23.31,14.62a4.68,4.68,0,0,0,3.07-.38c4.18.87,5.84-.85,5.84-.85,4.15-.39,5.61-2.38,5.61-2.38s4.92,1,6-1.91c1.21-3.23-5.94-3.95-9.63-6.75-8.46-6.41-18.69-17.9-20.94-20Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.46,267a69,69,0,0,0,7.72,5.2,68.05,68.05,0,0,0,9.45,3.85.08.08,0,0,1-.05.16,36.07,36.07,0,0,1-17.2-9.1C345.27,267,345.33,266.87,345.46,267Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.85,271.5c2.55,1.65,7.07,4.53,16.25,6.89,0,0,0,.07,0,.06a32.3,32.3,0,0,1-16.32-6.83C340.62,271.51,340.68,271.39,340.85,271.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.41,274a51,51,0,0,0,12.8,5.33s0,.06,0,.05c-6.1-1.17-8.18-2.29-12.9-5.24C338.14,274,338.24,273.89,338.41,274Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.5,244.06,324,266.86s-19-13.18-22.78-22.11.95-29.91,4.63-41.2S318,188.4,319.55,207s3.21,26.8,3.76,27.69S335.5,244.06,335.5,244.06Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.75,253.45c-.21-.75-5.32-4.8-7.23-11.63-.83-3-.46-11.64.35-17,.31-2.05.81-4.06,1.25-6.08.88-4.08,1.86-8.16,2.47-12.29,0-.05-.06-.06-.08,0-.87,2.53-1.58,5.12-2.2,7.73,0-.15,0-.29,0-.44a37.47,37.47,0,0,1-.09-3.82.08.08,0,0,0-.15,0c0,1.27-.17,2.52-.22,3.78,0,.61-.05,1.22,0,1.83,0,.23,0,.48,0,.73-.18.81-.36,1.62-.52,2.43-.41,2.07-.7,4.16-1.07,6.23-1,5.72-1.48,13.4-.43,17.55,1.79,7,7.66,10.68,7.79,11C307.65,253.53,307.78,253.55,307.75,253.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.48,263.13A58.51,58.51,0,0,0,323.3,258q1.35-2.57,2.65-5.14c1.75-3.47,3.6-6.92,5.13-10.5,0-.08-.08-.15-.13-.07-2.1,3.31-3.87,6.85-5.66,10.33q-1.35,2.63-2.62,5.29a49.39,49.39,0,0,0-2.33,5.2C320.31,263.16,320.43,263.2,320.48,263.13Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-179"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.72,356.44s-17.54,31-17.55,31C72.35,393.73,70,399.26,69,402.24c0,0,0,0,0,.05a4.94,4.94,0,0,0-.41,2.14s0,0,0,.06c1.3,2.1,50.63,26.07,52.63,26.33s2.89-5.43,1.72-7.89-16-20.09-16-20.09l17.22-31.14Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.47,430.64c-2-.26-50.54-24.06-51.83-26.15,0,0,0,0,0-.06a4.94,4.94,0,0,1,.41-2.14s0,0,0-.05c.95-3,3.31-8.51,6.12-14.77,0,0,3-5.42,4.14-7.3l31.37,16.22L107,402.84s14,17.45,15.17,19.91S122.48,430.9,120.47,430.64Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.37,430c-2-.31-51.16-25.63-52.42-27.78-.49-.81,2.78-8.19,7-17l.13-.27,31.9,16-.29.53s14.48,18.11,15.61,20.62S123.39,430.28,121.37,430Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.8,427.77c-8.18-4.47-41.6-21.73-50-25.53-.06,0-.09,0,0,.05,8,4.61,41.57,21.6,50,25.62C121.91,428,122,427.87,121.8,427.77Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.29,402.91c-2.94-2.29-7.19-3.84-10.88-2.8-.14,0-.08.24,0,.26a51.66,51.66,0,0,1,10.62,2.94A.23.23,0,0,0,110.29,402.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.91,405.54c-2.94-2.29-7.19-3.84-10.88-2.8-.14,0-.08.24,0,.26a51.66,51.66,0,0,1,10.62,2.94A.23.23,0,0,0,111.91,405.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.54,408.17c-3-2.29-7.19-3.84-10.88-2.8-.15,0-.09.24,0,.26a51.57,51.57,0,0,1,10.61,2.94A.23.23,0,0,0,113.54,408.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.35,394.61c-2.64-3.62-8.27.49-5.62,4.11S84,398.24,81.35,394.61Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.84,404.16l3.53,22.07c4.45,2.21,7.52,3.66,8,3.74,2,.31,3-5.41,1.92-7.91C122.43,420.16,113.92,409.3,109.84,404.16Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123,428.59c.71.79-1,3.65-1.76,3.56s-54.23-27.94-55-28.61,1.22-3.77,2.36-3.39S123,428.59,123,428.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.22,377.27l35.35,18.88s44.63-63.6,45.52-80.3c1.23-23.08-18.47-96.33-18.47-96.33l-31.43-.22s12.78,75.34,11.74,88.19C121.39,314.22,79.22,377.27,79.22,377.27Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.66,388.84c-1.82-1.31-18.58-11-31.34-17.22-.08,0-.14.08-.06.13C90.13,374.3,115.14,388,117.57,389,117.65,389,117.74,388.9,117.66,388.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.29,291.4c-1.46-11-3.06-22-4.89-33s-3.78-22-6.09-33c-.28-1.33-.57-2.66-.86-4a.17.17,0,0,0-.33.07c1.94,10.84,3.93,21.68,5.71,32.55s3.45,21.76,4.94,32.68c.37,2.7.73,5.41,1.08,8.11a72.23,72.23,0,0,1,.8,8.42,21.45,21.45,0,0,1-1.35,7.89,45.08,45.08,0,0,1-3.62,7.09c-5.68,9.62-31.15,51.66-31.81,52.88,0,.08.07.16.12.08,6.11-9.48,25.07-39.76,30.83-49.54,2.6-4.41,5.59-8.87,6.43-14C128.14,302.3,127,296.7,126.29,291.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.24,377.27s-.36,35.86-.36,35.88c.19,6.86.48,12.87.92,16a.07.07,0,0,0,0,.05,4.87,4.87,0,0,0,.56,2.11l0,0c2.07,1.32,56.92,1.41,58.84.77s.23-6.15-1.89-7.85-23.12-11.13-23.12-11.13V377.28Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117,405.79s-.08,7.34-.08,7.36c.19,6.86.48,12.87.92,16a.07.07,0,0,0,0,.05,9.7,9.7,0,0,0,.56,2.11l0,0c2.07,1.32,56.92,1.41,58.84.77s.23-6.15-1.89-7.85-23.12-11.13-23.12-11.13v-7.47Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.28,432c-1.94.62-57.22-.36-59.3-1.73-.8-.51-1.13-8.57-1.24-18.33v-.3l35.67.22,0,.61s21,9.84,23.13,11.59S179.23,431.4,177.28,432Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.7,429.85c-9.32-.39-46.93-1.09-56.16-.77-.08,0-.08.05,0,.05,9.22.6,46.83,1,56.15.88C176.89,430,176.89,429.86,176.7,429.85Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.38,412.64c-3.66-.75-8.15-.26-11,2.3-.11.1,0,.25.15.22a51.67,51.67,0,0,1,10.83-2.06A.23.23,0,0,0,155.38,412.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158,414.28c-3.66-.75-8.15-.26-11,2.3-.11.1,0,.25.15.22A51.67,51.67,0,0,1,158,414.74.23.23,0,0,0,158,414.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.62,415.92c-3.66-.75-8.15-.26-11,2.3-.11.1,0,.26.15.22a51,51,0,0,1,10.82-2.05A.24.24,0,0,0,160.62,415.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.16,430c1,.4.71,3.72,0,4s-61-1.07-62-1.32-.57-3.91.62-4.08S178.16,430,178.16,430Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.75,418c-4-2.08-7.2,4.09-3.22,6.17S129.73,420.08,125.75,418Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.22,219.44v0c-.21.64-11.5,31.59-12.56,32.09-1.21.55,24.95,44.49,26.49,64.9,1,13-.95,86.92-.95,86.92H116s1.83-66.41,2.71-87.46c.34-8.16-26.26-48.78-26.58-74.08-.11-8,5.62-22.55,5.62-22.55Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.89,315.36c0-.33-.27-.44-.3-.1-.86,11.39-1.06,22.72-1.6,34.13s-.24,14.11-.75,25.49c-.28,6.44,0,12.89-.16,19.33a.08.08,0,0,0,.16,0C117.43,382.87,118.88,321.81,118.89,315.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.14,316.91a56,56,0,0,0-.77-8.38,41.68,41.68,0,0,0-2.36-7.87c-2.11-5.33-4.61-10.52-7-15.73s-4.88-10.53-7.43-15.74q-2.16-4.41-4.33-8.78c-1.47-3-3.05-5.86-4.59-8.78a.1.1,0,1,0-.18.09c2.45,5.26,4.87,10.54,7.32,15.8s4.85,10.54,7.26,15.83,4.74,10.39,7,15.64a51.91,51.91,0,0,1,2.73,7.74,45,45,0,0,1,1.12,8.33c.37,6.53.55,13.08,1.19,19.59,0,.08.15.08.15,0C155.41,328.75,155.32,322.81,155.14,316.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.42,395.83c-2.22-.29-19.16-.87-33.33-.27a.08.08,0,0,0,0,.15c4.62.41,30.72.59,33.32.29C151.49,396,151.52,395.85,151.42,395.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.93,249.85A72.19,72.19,0,0,0,122,254a.13.13,0,0,0,.08.25c4-1.26,8.09-2.43,12-3.91A.25.25,0,0,0,133.93,249.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.79,223.64c0-.14-.23-.19-.24,0-.44,4.57-1.14,8.56-2,12.78-.39,2-3.1,12.74-6.45,11.59-.56-.19-.8-.78-.8-1.66a13.9,13.9,0,0,1,.8-3.31c.62-2.25,1.16-4.52,1.59-6.81a63.35,63.35,0,0,0,1.19-13,.11.11,0,1,0-.22,0A119.73,119.73,0,0,1,128.82,241c-.72,2.8-2.6,6.94.34,7.68s5.68-6.22,6.25-8.14A65.81,65.81,0,0,0,137.79,223.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.2,248.27a18.9,18.9,0,0,0-1,2.19,5.38,5.38,0,0,0-.51,1.83c0,.12.16.15.23.07a6.59,6.59,0,0,0,1-1.73c.33-.67.68-1.34,1-2A.38.38,0,0,0,129.2,248.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.8,326.6c.2-5.43.8-11.14-1-16.38a55.36,55.36,0,0,0-3.49-7.44c-1.33-2.56-2.62-5.13-3.9-7.71-5.11-10.32-9.92-20.8-14.23-31.48a66.94,66.94,0,0,1-4.66-15.95,49.16,49.16,0,0,1,1.07-17.34q.48-2.13,1-4.23c0-.1-.12-.16-.15,0a56.86,56.86,0,0,0-3,16.59,47,47,0,0,0,2.88,15.85c1.83,5.34,4.13,10.53,6.39,15.69q3.49,8,7.26,15.85c2.51,5.22,5.17,10.35,7.81,15.49a27.86,27.86,0,0,1,2.94,7.81,40.19,40.19,0,0,1,.31,8.56c-.45,12-1.48,52.05-1.64,64,0,1.53,0,3.05,0,4.57a.11.11,0,0,0,.21,0C121.39,378.52,122.37,338.59,122.8,326.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.22,227.23c0-.08-.13-.07-.14,0-.45,3.31-.71,6.74-2.31,9.75a13.58,13.58,0,0,1-6.81,5.77,49.16,49.16,0,0,1-5,1.83c-.12,0-.09.23,0,.2,3.16-.66,6.37-1.39,9.12-3.17a11.38,11.38,0,0,0,4.94-8.35A28.36,28.36,0,0,0,114.22,227.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.24,171.81c7.93,11.54,30.33,26.92,37,27.7,8.2,1,24.29-14.51,30.21-23.2,2.45-3.59-11.07-16.35-16.09-15.07-2.75.7-15.37,16.83-17.86,16.12-6-1.7-14.52-5.63-26.65-10.83C134.23,163.7,129.31,164.63,134.24,171.81Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.8,166.72a65,65,0,0,1,4.23-8.56c1.7-2.44,11.4-9.21,13-7.2,2,2.59-2.79,7.6-5.47,9.75,0,0,4.73,6,2,10.35S179.8,166.72,179.8,166.72Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.51,178.69c2-1.51,10.77-9.27,12.72-12s7-10.89,5.06-12.59-3.58.58-3.58.58,1.58-3.79-.51-5.33-4.56,2.09-4.56,2.09,1.34-4-.85-5.39-4.07,2.68-4.07,2.68,1.39-3.61-.89-4c-2.75-.46-4.57,6.49-6.94,9.31-.54.64-11.85,12.21-11.85,12.21Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.89,148.42c-1.35,5.1-2.83,7.1-6.63,10.64-.08.07,0,.2.09.13,4.05-3.12,6.26-5.37,6.79-10.72C204.16,148.21,204,148.17,203.89,148.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.74,151.07c-1.87,5.18-3.45,7.36-7.16,11.36-.05.06,0,.16.1.1,4-3.62,6.12-5.91,7.31-11.33C209,151,208.83,150.83,208.74,151.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.51,154.91c-2.16,4.88-3.79,7.35-7.9,10.78a.1.1,0,1,0,.12.15A17.77,17.77,0,0,0,213.66,155C213.75,154.67,213.65,154.6,213.51,154.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.34,151.86c.15,3.71-3.56,6.29-6,8.57a.3.3,0,0,0,0,.5c1.82,2.65,3.6,6.91,2.4,10.08a.08.08,0,0,0,.14.06c1.75-3.22.34-7.55-1.83-10.32,2.54-2.3,6.15-5.06,5.28-8.9C197.37,151.83,197.34,151.83,197.34,151.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.8,172,151,191.52s-16.09-15.65-19.52-21.59c-3.87-6.68.4-7.2,7.5-5.36S156.8,172,156.8,172Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.05,171.59c-1.07,2.39-3.3,10-3.68,11.27-.2.66-.88,3.34-1.08,4,0,.09.11.11.13,0,.39-1.26.92-2.48,1.32-3.74s2.94-8.93,3.41-11.53A.05.05,0,0,0,153.05,171.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.46,169.92c3.43,5.94,19.52,21.59,19.52,21.59l3-10.08L132.1,163.74C129.74,164.14,129.16,165.94,131.46,169.92Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.54,227.58s54.05,10.47,54.05,10.47c-.21,1.06,5.18-42.92-3.9-71.16-.62-1.93-8.75-5.45-13.17-2.72C110.18,176.12,92.41,228.27,92.54,227.58Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.86,235.08c0,.36-.06.68-.09,1L93,226.25l.34-.94Zm-51-16.15-.37.93,51.85,9.47c0-.32.05-.65.07-1Zm2.58-6.36-.39.93,49.68,9.07c0-.32,0-.65,0-1Zm2.73-6.33c-.13.31-.27.61-.4.92l47.19,8.62c0-.33,0-.66,0-1ZM148,208l-43.93-8c-.15.31-.29.61-.44.91L148,209C148,208.63,148,208.3,148,208Zm-.16-6.86-40.67-7.43-.46.91,41.17,7.52C147.85,201.78,147.84,201.45,147.82,201.11Zm-.37-6.9-36.93-6.75c-.18.3-.35.6-.51.91l37.5,6.85C147.5,194.89,147.47,194.55,147.45,194.21Zm-.65-7-32.6-5.95c-.19.29-.37.59-.56.89l33.28,6.08C146.88,187.94,146.85,187.6,146.8,187.26Zm-1-7-27.47-5-.65.88L146,181.29C146,180.94,145.89,180.6,145.84,180.25Zm-1.42-7.09-21.07-3.85-.81.86,22.12,4Zm-1.73-6.27a2.56,2.56,0,0,0-.83-1h0l-11.53-2.1a5.48,5.48,0,0,0-.8.41c-.18.11-.35.22-.53.35L142.73,167C142.72,167,142.7,166.94,142.69,166.89Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.52,149.29s-9.52,8.27-8.27,10.06,14.07.65,17-1.25,8.9-10.27,8.9-10.27Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.52,149.29s-9.52,8.27-8.27,10.06,14.07.65,17-1.25,8.9-10.27,8.9-10.27Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.34,173.29c-2.63.57-8-2.61-9.84-6.39a60.5,60.5,0,0,1,.9-6.11c.3-2,.58-4.15.69-6.16,0-.42,12.46,3.77,12.46,3.77a32.47,32.47,0,0,0-1.65,7.67,5.56,5.56,0,0,0,0,.83.57.57,0,0,1,0,.14C143.12,168.62,143.16,172.68,140.34,173.29Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143,166.9V167a8,8,0,0,1-1.29,0c-7.43-.58-8.87-10-9.12-12.37,2.23.44,12,3.74,12,3.74a32.61,32.61,0,0,0-1.65,7.67A3.75,3.75,0,0,0,143,166.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.62,138.81c-1.48,4.46.58,17.47,3.7,20.44,4.53,4.3,12.09,4.88,15.78-.6,3.58-5.3.6-22.22-2.9-24.93C142,129.73,132.8,132.24,130.62,138.81Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.08,146.87s-.07.06-.06.09c.16.87.2,1.9-.55,2.31,0,0,0,.06,0,0C143.43,149,143.37,147.67,143.08,146.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.15,146.08c-1.43.11-1.1,2.95.22,2.85S143.35,146,142.15,146.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.2,146.44s.07,0,.07.07c.08.88.31,1.88,1.14,2.09,0,0,0,.05,0,.05C148.42,148.62,148.12,147.29,148.2,146.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.88,145.43c1.41-.27,1.84,2.56.54,2.81S147.7,145.65,148.88,145.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.88,144.9a10.32,10.32,0,0,0,1.06-.51,1.89,1.89,0,0,0,1-.73.62.62,0,0,0-.18-.72,1.5,1.5,0,0,0-1.52,0,2.21,2.21,0,0,0-1.16,1.09A.64.64,0,0,0,140.88,144.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.82,143.87a11.78,11.78,0,0,1-1.17-.17,1.82,1.82,0,0,1-1.15-.39.6.6,0,0,1-.05-.74,1.49,1.49,0,0,1,1.45-.45,2.26,2.26,0,0,1,1.44.69A.64.64,0,0,1,149.82,143.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.19,155.15c.23.18.48.44.8.43a2.22,2.22,0,0,0,.92-.33,0,0,0,0,1,.05.05,1.2,1.2,0,0,1-1.07.6.94.94,0,0,1-.78-.7S143.15,155.12,143.19,155.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.82,152.4a3,3,0,0,0,2.15,1.11,4,4,0,0,0,1.09-.07l.2-.05.19,0a.24.24,0,0,0,.16-.22h0a.28.28,0,0,0,0-.09h0l0-.08c0-.68-.24-1.7-.24-1.7.27.09,1.59.52,1.53.17a45.08,45.08,0,0,0-2.19-9c0-.09-.18,0-.16,0,.38,2.83,1.25,5.56,1.67,8.39a5.47,5.47,0,0,0-1.46-.27c-.1,0,.39,2,.39,2.29v0a4.21,4.21,0,0,1-3.22-.61C143.82,152.27,143.76,152.34,143.82,152.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.25,151.43c2.41-.89,3-9.26,3-9.26s.25,3.51.9,3.37,3-5.1,3-8.54a27,27,0,0,0,6.48,2.56c3.19.69,6.19,1.16,6.15.63-.12-1.58-2-5.91-4.23-7.2a10.44,10.44,0,0,0-10.8-.46c-4.95,2.35-5.9,5.06-6.46,7.66S130.37,151.76,131.25,151.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.48,131.8c-4.43-2.18-14-1-15.84,6.62a22.47,22.47,0,0,0,.09,10s5.63-5.51,7.85-6.6c5.64-2.77,13.31-2.27,13.31-2.27S149.46,133.75,145.48,131.8Zm-7,8c-.06-1.3.33-3.23,3.14-3.84a3.33,3.33,0,0,1,4.07,2.3A22.58,22.58,0,0,0,138.47,139.77Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.64,149.6s-2.91-4.2-4.82-3.17.28,7.13,2.51,8a2.26,2.26,0,0,0,3-1.21Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.49,148.16a0,0,0,0,0,0,.06,5.75,5.75,0,0,1,3,3.61,1.24,1.24,0,0,0-1.87-.35s0,.09,0,.08a1.39,1.39,0,0,1,1.53.49,6.85,6.85,0,0,1,.74,1.25c.07.14.32.06.27-.1v0C133.17,151.17,131.63,148.37,129.49,148.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.58,178.8c-2,13.1-6.86,40.2-1.38,48.35,7.2,10.69,31.26,18,37.56,20.13,2.75.95,10.09-16.94,8.58-19.65s-26.48-12.94-28.18-14.52-3.87-23.06-6.06-34.1C131.33,165.09,125.25,167.7,123.58,178.8Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.83,234c-1-1.11-.41-1.63,2.18-1.16s12.44,4.53,13.57,1-12.86-9.08-17.23-9.53a69.28,69.28,0,0,0-11.6.34C165.25,226.26,171,230.77,175.83,234Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.9,244.28c7.22,4.31,15.95,10.12,25.44,10.18a4.71,4.71,0,0,0,2.94-.92c4.25.1,5.58-1.88,5.58-1.88,4-1.12,5.06-3.33,5.06-3.33s5,.07,5.54-2.94c.61-3.38-6.52-2.81-10.64-4.89-9.43-4.78-21.49-14.21-24.07-15.86Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.42,242.43a69,69,0,0,0,8.5,3.72,67.41,67.41,0,0,0,9.93,2.09.09.09,0,0,1,0,.17,36,36,0,0,1-18.48-5.85C173.23,242.48,173.28,242.36,173.42,242.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.71,247.7c2.8,1.17,7.74,3.18,17.16,3.86,0,0,0,.06,0,.06a32.22,32.22,0,0,1-17.21-3.78C169.49,247.75,169.53,247.63,169.71,247.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.77,250.58a51.21,51.21,0,0,0,13.49,2.94,0,0,0,0,1,0,0c-6.18-.06-8.42-.79-13.57-2.84C167.51,250.66,167.58,250.51,167.77,250.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.72,194.1l-19.22,6.39s3.58-22,6.46-28.15c3.24-7,6.08-3.77,8.63,3S137.72,194.1,137.72,194.1Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.89,190.85c-2.56.48-10,3-11.26,3.41-.65.22-3.22,1.18-3.87,1.39-.09,0,0,.15,0,.13,1.25-.4,2.54-.67,3.79-1.06s8.94-2.68,11.32-3.78C136,190.92,136,190.83,135.89,190.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.42,180.92c0-.09-.11-.1-.14,0-.51,1.82-1,3.66-1.42,5.5a16.48,16.48,0,0,1,.28-3s-.06-.05-.07,0a13.09,13.09,0,0,0-.31,3.42c-.3,1.29-.59,2.57-.87,3.86-.7,3.29-1.44,6.57-2,9.89a.23.23,0,0,0,.31.25c.66-.24,1.31-.5,2-.79.07,0,0-.15,0-.13-.57.11-1.14.25-1.7.4.76-3.15,1.36-6.35,2-9.52S121.86,184.23,122.42,180.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.59,185.48c-.07-1.07-.14-2.14-.25-3.2,0,0,0,0,0,0,0,.79.07,1.57.11,2.36-.33-1.53-.7-3.06-1.14-4.56,0,0,0,0,0,0,.32,2.35.77,4.69,1.15,7s.77,4.6,1.18,6.89c-.41.22-.83.42-1.25.62a.07.07,0,0,0,.05.13c.49-.14,1-.28,1.48-.4a.22.22,0,0,0,.2-.24C137.67,191.23,137.2,188.34,136.59,185.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226,69.42l10.28,6.69.12.09-10.29-6.7Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.16,249.05l-10.28-6.69.41.25,10.28,6.7Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "207.39 131.17 217.67 137.87 166.96 215.91 156.67 209.22 207.39 131.17",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "207.39 131.17 217.67 137.87 166.96 215.91 156.67 209.22 207.39 131.17"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M226.38,240.8l-89.25,10.74c-1,.12-1.54.16-2,.18a13.12,13.12,0,0,1-8-2L116.85,243a13.17,13.17,0,0,0,8,2c.49,0,1-.06,2-.18l89.25-10.73Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M226.38,240.8l-89.25,10.74c-1,.12-1.54.16-2,.18a13.12,13.12,0,0,1-8-2L116.85,243a13.17,13.17,0,0,0,8,2c.49,0,1-.06,2-.18l89.25-10.73Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M255.06,205.33l-10.28-6.7-9.86-116.5c0-.28,0-.57-.08-.87,0-.57-.36-.83-.4-1.4a3.13,3.13,0,0,0-.43-1.7c0-.29-.36-.83-.38-1.12a12.86,12.86,0,0,0-.72-1.66,2,2,0,0,1-.66-1.09A8.7,8.7,0,0,0,231,73c-.32-.25-.65-.79-1-1s-.63-.5-1.24-1a.38.38,0,0,0-.15-.24l10.19,6.63c.14.1.23.19.24.31.62.49.93.76,1.23,1s.65.8,1,1a8.12,8.12,0,0,1,1.27,1.3,2.12,2.12,0,0,0,.66,1.09,11.12,11.12,0,0,1,.72,1.66c0,.29.36.83.38,1.12a3.09,3.09,0,0,1,.43,1.69c.05.58.36.83.41,1.41,0,.29.05.58.08.87Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M255.06,205.33l-10.28-6.7-9.86-116.5c0-.28,0-.57-.08-.87,0-.57-.36-.83-.4-1.4a3.13,3.13,0,0,0-.43-1.7c0-.29-.36-.83-.38-1.12a12.86,12.86,0,0,0-.72-1.66,2,2,0,0,1-.66-1.09A8.7,8.7,0,0,0,231,73c-.32-.25-.65-.79-1-1s-.63-.5-1.24-1a.38.38,0,0,0-.15-.24l10.19,6.63c.14.1.23.19.24.31.62.49.93.76,1.23,1s.65.8,1,1a8.12,8.12,0,0,1,1.27,1.3,2.12,2.12,0,0,0,.66,1.09,11.12,11.12,0,0,1,.72,1.66c0,.29.36.83.38,1.12a3.09,3.09,0,0,1,.43,1.69c.05.58.36.83.41,1.41,0,.29.05.58.08.87Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M275.23,218.92A16.57,16.57,0,0,1,260.6,236.7l-2.86.34-10.27-6.7,2.84-.34A16.55,16.55,0,0,0,265,212.23,15.25,15.25,0,0,0,258,200.68l10.28,6.69A15.29,15.29,0,0,1,275.23,218.92Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M275.23,218.92A16.57,16.57,0,0,1,260.6,236.7l-2.86.34-10.27-6.7,2.84-.34A16.55,16.55,0,0,0,265,212.23,15.25,15.25,0,0,0,258,200.68l10.28,6.69A15.29,15.29,0,0,1,275.23,218.92Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M259.61,259a16.32,16.32,0,0,1-14.35,17.74,11,11,0,0,1-1.28.1,15.09,15.09,0,0,1-9-2.39l-10.28-6.7a15.15,15.15,0,0,0,9,2.4c.42,0,.85-.05,1.27-.1a16.31,16.31,0,0,0,14.35-17.74l-1.85-21.93,10.27,6.7Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M259.61,259a16.32,16.32,0,0,1-14.35,17.74,11,11,0,0,1-1.28.1,15.09,15.09,0,0,1-9-2.39l-10.28-6.7a15.15,15.15,0,0,0,9,2.4c.42,0,.85-.05,1.27-.1a16.31,16.31,0,0,0,14.35-17.74l-1.85-21.93,10.27,6.7Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M265,212.22A16.56,16.56,0,0,1,250.32,230l-2.85.34,1.85,21.92A16.3,16.3,0,0,1,235,270c-.43.06-.86.09-1.28.11A15,15,0,0,1,218,256l-1.85-21.92-89.25,10.73c-1,.12-1.54.16-2,.19a13.12,13.12,0,0,1-8.53-2.42c-7.59-4.62-9.28-14.33-4.44-21.89L206.12,75.4c.29,0,.27-.33.53-.65a4.36,4.36,0,0,0,.75-1.25,3.21,3.21,0,0,0,1.35-1c.27-.33.81-.68,1.07-1a3.15,3.15,0,0,1,1.66-.78c.24-.62.5-.94,1.07-1,.26-.33.83-.4,1.67-.79a1.75,1.75,0,0,0,1.11-.43l2-.23.57-.07.57-.07,1.71-.21a2.18,2.18,0,0,0,.94.17c.82.2,1.67.1,2.27.32a12.14,12.14,0,0,1,2.68,1.13c.6.22.91.48,1.51.7s1.19.45,1.21.73l1.23,1c.32.26.65.8,1,1.06a7.49,7.49,0,0,1,1.27,1.29,2.18,2.18,0,0,0,.66,1.1,12.27,12.27,0,0,1,.72,1.66c0,.29.36.83.38,1.12a3.09,3.09,0,0,1,.43,1.69c.05.57.36.83.41,1.4,0,.29.05.58.07.87l9.86,116.5,2.85-.35c.42-.05.83-.08,1.24-.1A15.38,15.38,0,0,1,265,212.22Zm-108.28-3,56.75-6.82-6-71.23-50.72,78.05",
    style: {
      fill: "#FFC727"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPagenotfound);
export default __webpack_public_path__ + "static/media/page not found.417ff0ae879e03a1ae034b023bf09b41.svg";
export { ForwardRef as ReactComponent };